import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSONObject: any;
  Upload: any;
};

export type AccountStatus = {
  __typename?: 'AccountStatus';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  type: AccountType;
};

export enum AccountType {
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Helper = 'HELPER'
}

export type ActivateAccountResult = {
  __typename?: 'ActivateAccountResult';
  activated: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type BlendrConnector = {
  __typename?: 'BlendrConnector';
  authentication_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  name: Scalars['String'];
};

export type BlendrConnectorPaginationInfo = {
  __typename?: 'BlendrConnectorPaginationInfo';
  current_page: Scalars['Int'];
  per_page: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlendrConnectorResponse = {
  __typename?: 'BlendrConnectorResponse';
  data: Array<BlendrConnector>;
  meta?: Maybe<BlendrConnectorPaginationInfo>;
};

export type BlendrDataSource = {
  __typename?: 'BlendrDataSource';
  connector: BlendrDataSourceConnector;
  created_at: Scalars['DateTime'];
  guid: Scalars['String'];
  is_connected: Scalars['Boolean'];
  is_used: Scalars['Boolean'];
  name: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type BlendrDataSourceConnector = {
  __typename?: 'BlendrDataSourceConnector';
  guid: Scalars['String'];
  name: Scalars['String'];
};

export type BlendrTemplate = {
  __typename?: 'BlendrTemplate';
  activation_url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  guid: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  icon2?: Maybe<Scalars['String']>;
  isbundle?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  short_description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  activated: Scalars['Boolean'];
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  isPremium: Scalars['Boolean'];
  lastName: Scalars['String'];
};

export type ClientListOfHelpers = {
  __typename?: 'ClientListOfHelpers';
  invited: Array<Maybe<Helper>>;
  pending: Array<Maybe<Helper>>;
  requested: Array<Maybe<Helper>>;
};

export type ClientProfileData = {
  __typename?: 'ClientProfileData';
  company: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  helpers: Array<Maybe<ClientProfileHelpers>>;
  lastName: Scalars['String'];
};

export type ClientProfileHelpers = {
  __typename?: 'ClientProfileHelpers';
  email: Scalars['String'];
  isAccepted: Scalars['Boolean'];
  isClientHelper: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ClientProjectsReport = {
  __typename?: 'ClientProjectsReport';
  CSV?: Maybe<Scalars['String']>;
  JSON?: Maybe<Array<Maybe<Project>>>;
};

export type ClientsList = {
  __typename?: 'ClientsList';
  clients?: Maybe<Array<Maybe<Client>>>;
  pagesCount: Scalars['Int'];
};

export type CreateProjectInput = {
  adminInstructionFileName?: InputMaybe<Scalars['String']>;
  adminShortInstruction?: InputMaybe<Scalars['String']>;
  annotationImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  auditorRate?: InputMaybe<Scalars['Int']>;
  authToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  clientInstructionFileNames?: InputMaybe<Array<Scalars['String']>>;
  clientShortInstruction?: InputMaybe<Scalars['String']>;
  customLabels: Scalars['Boolean'];
  files?: InputMaybe<Array<InputMaybe<GoogleDriveFiles>>>;
  helperRate?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mediaFileName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mlLabels?: InputMaybe<MlInput>;
  platform?: InputMaybe<Platform>;
  projectSettings?: InputMaybe<IProjectSettings>;
  title: Scalars['String'];
  type: TaskType;
};

export type CreateVideoAnnotationProjectInput = {
  adminInstructionFileName?: InputMaybe<Scalars['String']>;
  adminShortInstruction?: InputMaybe<Scalars['String']>;
  auditorRate?: InputMaybe<Scalars['Int']>;
  clientId?: InputMaybe<Scalars['Int']>;
  clientInstructionFileNames?: InputMaybe<Array<Scalars['String']>>;
  clientShortInstruction?: InputMaybe<Scalars['String']>;
  customLabels: Scalars['Boolean'];
  helperRate?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mediaFileName?: InputMaybe<Array<Scalars['String']>>;
  mlLabels?: InputMaybe<MlInput>;
  platform?: InputMaybe<Platform>;
  projectSettings?: InputMaybe<IProjectSettings>;
  title: Scalars['String'];
  type: TaskType;
};

export type DraftCreateProjectInput = {
  adminInstructionFileName?: InputMaybe<Scalars['String']>;
  adminShortInstruction?: InputMaybe<Scalars['String']>;
  annotationImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  assignedAuditorIds?: InputMaybe<Array<Scalars['Int']>>;
  assignedHelperIds?: InputMaybe<Array<Scalars['Int']>>;
  auditorRate?: InputMaybe<Scalars['Int']>;
  authToken?: InputMaybe<Scalars['String']>;
  clientInstructionFileNames?: InputMaybe<Array<Scalars['String']>>;
  clientShortInstruction?: InputMaybe<Scalars['String']>;
  customLabels?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<Array<InputMaybe<GoogleDriveFiles>>>;
  helperRate?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mediaFileName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mlLabels?: InputMaybe<MlInput>;
  platform?: InputMaybe<Platform>;
  projectSettings?: InputMaybe<IProjectSettings>;
  status?: InputMaybe<ProjectStatus>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TaskType>;
};

export type GoogleDriveFiles = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: GoogleFileType;
};

export enum GoogleFileType {
  Photo = 'photo',
  Video = 'video'
}

export type Helper = {
  __typename?: 'Helper';
  activated: Scalars['Boolean'];
  activatedAt?: Maybe<Scalars['DateTime']>;
  assignedToProjectAsAuditor?: Maybe<Scalars['Boolean']>;
  assignedToProjectAsHelper?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  invitedBy?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  penaltyRateAsAuditor?: Maybe<Scalars['Float']>;
  penaltyRateAsHelper?: Maybe<Scalars['Float']>;
  projectsCountAsAuditor?: Maybe<Scalars['Int']>;
  projectsCountAsHelper?: Maybe<Scalars['Int']>;
  returnRateAsAuditor?: Maybe<Scalars['Float']>;
  returnRateAsHelper?: Maybe<Scalars['Float']>;
  topProjects?: Maybe<Array<TopProject>>;
  totalProjectsCount?: Maybe<Scalars['Int']>;
};

export type HelperAllTimeStatistic = {
  __typename?: 'HelperAllTimeStatistic';
  dailyStat: HelperBaseStatistic;
  projectDone: Scalars['Int'];
  taskCompleted: Scalars['Int'];
  taskReturned: Scalars['Int'];
  totalEarned: Scalars['Float'];
};

export type HelperBaseStatistic = {
  __typename?: 'HelperBaseStatistic';
  projectDone: Scalars['Int'];
  taskCompleted: Scalars['Int'];
  taskReturned: Scalars['Int'];
  totalEarned: Scalars['Float'];
};

export type HelperReport = {
  __typename?: 'HelperReport';
  CSV?: Maybe<Scalars['String']>;
  JSON?: Maybe<Array<Maybe<HelperReportEntity>>>;
};

export type HelperReportEntity = {
  __typename?: 'HelperReportEntity';
  auditorPoints: Scalars['Int'];
  auditorRate: Scalars['Int'];
  auditorTasks: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  helperPoints: Scalars['Int'];
  helperPointsWithPenalties: Scalars['Int'];
  helperRate: Scalars['Int'];
  id: Scalars['ID'];
  penalties: Scalars['Int'];
  title: Scalars['String'];
  totalEarned: Scalars['Int'];
};

export type HelperStats = {
  __typename?: 'HelperStats';
  auditorPoints: Scalars['Int'];
  auditorRate: Scalars['Int'];
  auditorTasksCount?: Maybe<Scalars['Int']>;
  firstName: Scalars['String'];
  helperPoints: Scalars['Int'];
  helperRate: Scalars['Int'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  penalties: Scalars['Int'];
};

export type HelperStatsReport = {
  __typename?: 'HelperStatsReport';
  CSV?: Maybe<Scalars['String']>;
  JSON?: Maybe<Array<Maybe<HelperStats>>>;
};

export type HelpersList = {
  __typename?: 'HelpersList';
  helpers?: Maybe<Array<Maybe<Helper>>>;
  pagesCount: Scalars['Int'];
};

export type IProjectSettings = {
  annotationType?: InputMaybe<Scalars['String']>;
  chunkLength?: InputMaybe<Scalars['Float']>;
  processingType?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<Scalars['String']>;
};

export type LearningMaterialStructure = {
  __typename?: 'LearningMaterialStructure';
  topics?: Maybe<Array<Maybe<LearningMaterialTopicStructure>>>;
};

export type LearningMaterialTopicLessonsStructure = {
  __typename?: 'LearningMaterialTopicLessonsStructure';
  id: Scalars['Int'];
  isDone: Scalars['Boolean'];
  title: Scalars['String'];
};

export type LearningMaterialTopicStructure = {
  __typename?: 'LearningMaterialTopicStructure';
  id: Scalars['Int'];
  lessons?: Maybe<Array<Maybe<LearningMaterialTopicLessonsStructure>>>;
  title: Scalars['String'];
};

export type LessonLearningMaterial = {
  __typename?: 'LessonLearningMaterial';
  description: Scalars['String'];
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  practice?: Maybe<Array<Maybe<LessonLearningMaterialPractice>>>;
};

export type LessonLearningMaterialPractice = {
  __typename?: 'LessonLearningMaterialPractice';
  avgResult: Scalars['Float'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type LessonPracticeSessionInfo = {
  __typename?: 'LessonPracticeSessionInfo';
  sessionEndDate?: Maybe<Scalars['DateTime']>;
  task?: Maybe<LessonPracticeTask>;
  totalSessionSize?: Maybe<Scalars['Int']>;
};

export type LessonPracticeTask = {
  __typename?: 'LessonPracticeTask';
  labels?: Maybe<Array<Scalars['String']>>;
  mediaFileName?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  settings?: Maybe<ProjectSettings>;
  type: TaskType;
  videoChunkLength?: Maybe<Scalars['Float']>;
  videoEnd?: Maybe<Scalars['Float']>;
  videoFPS?: Maybe<Scalars['Float']>;
  videoFrameCount?: Maybe<Scalars['Float']>;
  videoStart?: Maybe<Scalars['Float']>;
};

export type LessonPracticeTaskSubmit = {
  __typename?: 'LessonPracticeTaskSubmit';
  currentTaskIndex?: Maybe<Scalars['Int']>;
  next?: Maybe<LessonPracticeTask>;
  result?: Maybe<Scalars['Int']>;
  totalSessionSize?: Maybe<Scalars['Int']>;
};

export type LessonProgress = {
  __typename?: 'LessonProgress';
  id: Scalars['Int'];
};

export type LoginResponseAdmin = {
  __typename?: 'LoginResponseAdmin';
  admin?: Maybe<Admin>;
  token?: Maybe<Scalars['String']>;
};

export type LoginResponseClient = {
  __typename?: 'LoginResponseClient';
  client?: Maybe<Client>;
  token?: Maybe<Scalars['String']>;
};

export type LoginResponseHelper = {
  __typename?: 'LoginResponseHelper';
  helper?: Maybe<Helper>;
  token?: Maybe<Scalars['String']>;
};

export type Ml = {
  __typename?: 'ML';
  multilabels?: Maybe<Array<MLabelsType>>;
};

export type MlInput = {
  multilabels?: InputMaybe<Array<MLabels>>;
};

export type MlTrigger = {
  items: Array<Scalars['String']>;
  parentId: Scalars['String'];
};

export type MlTriggerType = {
  __typename?: 'MLTriggerType';
  items: Array<Scalars['String']>;
  parentId: Scalars['String'];
};

export enum Ml_Label_Type {
  Checkbox = 'CHECKBOX',
  Radiobutton = 'RADIOBUTTON',
  Text = 'TEXT'
}

export type MLabels = {
  entities: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  trigger?: InputMaybe<MlTrigger>;
  type: Ml_Label_Type;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type MLabelsType = {
  __typename?: 'MLabelsType';
  entities: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  trigger?: Maybe<MlTriggerType>;
  type: Ml_Label_Type;
};

export type Mutation = {
  __typename?: 'Mutation';
  ActivateAccountByToken: ActivateAccountResult;
  ChangePassword: Client;
  CreateProject: SaveProjectResult;
  CreateVideoAnnotationProject: SaveProjectResult;
  PasswordReset: PasswordResetResult;
  RequestPasswordReset: RequestPasswordResetResult;
  ToggleAccount: Scalars['Boolean'];
  acceptInviteByHelper: Scalars['Boolean'];
  archiveProject: Scalars['Boolean'];
  autosaveTask: Task;
  bulkUpdateTasks: BulkUpdateTasksResult;
  copyProject: SaveProjectResult;
  createClient: Client;
  createGoogleDriveProject: SaveProjectResult;
  createHelper: Helper;
  createMultiImageProject: SaveProjectResult;
  deleteClient: Client;
  deleteHelper: Helper;
  getReSendActivationLinkTime: Scalars['Int'];
  loginAdmin: LoginResponseAdmin;
  loginClient: LoginResponseClient;
  loginClientByGoogle: LoginResponseClient;
  loginHelper: LoginResponseHelper;
  projectAdminInstructionUpload: UploadResult;
  projectClientInstructionUpload: UploadResult;
  projectMediaUpload?: Maybe<Array<Scalars['String']>>;
  projectOverwriteTasks: Scalars['Boolean'];
  reSendActivationLink: Scalars['Boolean'];
  registerClient: LoginResponseClient;
  registerHelper: Helper;
  requestHelpers: Scalars['Int'];
  saveDraftProject: SaveProjectResult;
  saveLearningProgress?: Maybe<Array<Maybe<TopicProgress>>>;
  selectTask?: Maybe<Task>;
  sendClientActivationLink?: Maybe<Scalars['Boolean']>;
  sendRequestToHelper: Scalars['Boolean'];
  startAuditing: Task;
  startTasking: Task;
  submitLessonPractice?: Maybe<LessonPracticeTaskSubmit>;
  submitTask: SubmitTaskResult;
  updateAssignedAuditor: Project;
  updateAssignedHelper: Project;
  updateClient: Client;
  updateClientInfo: Client;
  updateFiles: Project;
  updateHelper: Helper;
  updateInfo: Project;
  updateProject: Project;
  updateRate: Project;
  updateStatus: Project;
  updateTask: Task;
  upgradeClientPlan: Scalars['Boolean'];
};


export type MutationActivateAccountByTokenArgs = {
  token: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCreateProjectArgs = {
  input?: InputMaybe<CreateProjectInput>;
};


export type MutationCreateVideoAnnotationProjectArgs = {
  input?: InputMaybe<CreateVideoAnnotationProjectInput>;
};


export type MutationPasswordResetArgs = {
  new_password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String'];
  role: AccountType;
};


export type MutationToggleAccountArgs = {
  accountId: Scalars['Int'];
  accountType: AccountType;
};


export type MutationAcceptInviteByHelperArgs = {
  inviteId: Scalars['Int'];
};


export type MutationArchiveProjectArgs = {
  projectId: Scalars['Int'];
};


export type MutationAutosaveTaskArgs = {
  result?: InputMaybe<Scalars['JSONObject']>;
  taskId: Scalars['Int'];
};


export type MutationBulkUpdateTasksArgs = {
  fromAuditorId?: InputMaybe<Scalars['Int']>;
  fromHelperId?: InputMaybe<Scalars['Int']>;
  fromStatus?: InputMaybe<TaskStatus>;
  projectId: Scalars['Int'];
  toAuditorId?: InputMaybe<Scalars['Int']>;
  toHelperId?: InputMaybe<Scalars['Int']>;
  toStatus?: InputMaybe<TaskStatus>;
};


export type MutationCopyProjectArgs = {
  newTitle: Scalars['String'];
  projectId: Scalars['Int'];
};


export type MutationCreateClientArgs = {
  companyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  sendInvite: Scalars['Boolean'];
};


export type MutationCreateGoogleDriveProjectArgs = {
  input?: InputMaybe<CreateProjectInput>;
};


export type MutationCreateHelperArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationCreateMultiImageProjectArgs = {
  input?: InputMaybe<CreateProjectInput>;
};


export type MutationDeleteClientArgs = {
  clientId: Scalars['Int'];
};


export type MutationDeleteHelperArgs = {
  helperId: Scalars['Int'];
};


export type MutationLoginAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginClientArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginClientByGoogleArgs = {
  googleToken: Scalars['String'];
};


export type MutationLoginHelperArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationProjectAdminInstructionUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationProjectClientInstructionUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationProjectMediaUploadArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  file: Scalars['Upload'];
};


export type MutationProjectOverwriteTasksArgs = {
  mediaFileName: Scalars['String'];
  projectId: Scalars['Int'];
};


export type MutationRegisterClientArgs = {
  companyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  termsVersion: Scalars['String'];
};


export type MutationRegisterHelperArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};


export type MutationRequestHelpersArgs = {
  comment: Scalars['String'];
  projectId: Scalars['Int'];
};


export type MutationSaveDraftProjectArgs = {
  input?: InputMaybe<DraftCreateProjectInput>;
};


export type MutationSaveLearningProgressArgs = {
  lesson: Scalars['Int'];
  topic: Scalars['Int'];
};


export type MutationSelectTaskArgs = {
  taskId: Scalars['Int'];
};


export type MutationSendClientActivationLinkArgs = {
  clientId: Scalars['Int'];
};


export type MutationSendRequestToHelperArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  projectId?: InputMaybe<Scalars['Int']>;
};


export type MutationStartAuditingArgs = {
  projectId: Scalars['Int'];
};


export type MutationStartTaskingArgs = {
  projectId: Scalars['Int'];
};


export type MutationSubmitLessonPracticeArgs = {
  lessonId: Scalars['Int'];
  practiceId: Scalars['Int'];
  result: Scalars['JSONObject'];
  topicId: Scalars['Int'];
};


export type MutationSubmitTaskArgs = {
  action: TaskAction;
  comment?: InputMaybe<Scalars['String']>;
  mlLabelsResult?: InputMaybe<MlInput>;
  result?: InputMaybe<Scalars['JSONObject']>;
  taskId: Scalars['Int'];
};


export type MutationUpdateAssignedAuditorArgs = {
  input?: InputMaybe<ProjectUpdateAuditorsInput>;
};


export type MutationUpdateAssignedHelperArgs = {
  input?: InputMaybe<ProjectUpdateHelpersInput>;
};


export type MutationUpdateClientArgs = {
  clientId: Scalars['Int'];
  companyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationUpdateClientInfoArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFilesArgs = {
  input?: InputMaybe<ProjectUpdateFilesInput>;
};


export type MutationUpdateHelperArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  helperId: Scalars['Int'];
  lastName: Scalars['String'];
};


export type MutationUpdateInfoArgs = {
  input?: InputMaybe<ProjectUpdateInfoInput>;
};


export type MutationUpdateProjectArgs = {
  input?: InputMaybe<ProjectUpdateInput>;
};


export type MutationUpdateRateArgs = {
  input?: InputMaybe<ProjectUpdateRateInput>;
};


export type MutationUpdateStatusArgs = {
  input?: InputMaybe<ProjectUpdateStatusInput>;
};


export type MutationUpdateTaskArgs = {
  fromAuditorId?: InputMaybe<Scalars['Int']>;
  fromHelperId?: InputMaybe<Scalars['Int']>;
  fromStatus?: InputMaybe<TaskStatus>;
  taskId: Scalars['Int'];
  toAuditorId?: InputMaybe<Scalars['Int']>;
  toHelperId?: InputMaybe<Scalars['Int']>;
  toStatus?: InputMaybe<TaskStatus>;
};


export type MutationUpgradeClientPlanArgs = {
  clientId: Scalars['Int'];
};

export type PasswordResetResult = {
  __typename?: 'PasswordResetResult';
  firstName?: Maybe<Scalars['String']>;
  reseted: Scalars['Boolean'];
};

export enum Platform {
  Hosted = 'HOSTED',
  Own = 'OWN'
}

export type PresignedPost = {
  __typename?: 'PresignedPost';
  filename?: Maybe<Scalars['String']>;
  presignedData?: Maybe<Scalars['String']>;
};

export type Project = {
  __typename?: 'Project';
  adminInstructionUrl?: Maybe<Scalars['String']>;
  adminShortInstruction?: Maybe<Scalars['String']>;
  auditorRate?: Maybe<Scalars['Int']>;
  auditorsCount?: Maybe<Scalars['Int']>;
  client?: Maybe<Client>;
  clientInstructionUrl?: Maybe<Array<Maybe<Scalars['String']>>>;
  clientShortInstruction?: Maybe<Scalars['String']>;
  completedTasksCount?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  customLabels: Scalars['Boolean'];
  helperRate?: Maybe<Scalars['Int']>;
  helpersCount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  inAuditTasksCount?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  isUserAuditor: Scalars['Boolean'];
  isUserHelper: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  mediaFileName?: Maybe<Array<Maybe<Scalars['String']>>>;
  mlLabels?: Maybe<Ml>;
  newTasksCount?: Maybe<Scalars['Int']>;
  platform: Platform;
  projectSettings?: Maybe<ProjectSettings>;
  projectStats?: Maybe<Array<Maybe<ProjectStatByHour>>>;
  readyForAudit?: Maybe<Scalars['Int']>;
  rejectedTasksCount?: Maybe<Scalars['Int']>;
  startedTasksCount?: Maybe<Scalars['Int']>;
  status: ProjectStatus;
  title: Scalars['String'];
  totalTasksCount?: Maybe<Scalars['Int']>;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workPoints: Scalars['Int'];
};

export type ProjectAssets = {
  __typename?: 'ProjectAssets';
  assets: Array<Scalars['String']>;
};

export type ProjectLabels = {
  labels?: InputMaybe<Array<Scalars['String']>>;
};

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  annotationType?: Maybe<Scalars['String']>;
  chunkLength?: Maybe<Scalars['Float']>;
  processingType?: Maybe<Scalars['String']>;
  subType?: Maybe<Scalars['String']>;
};

export type ProjectStatByHour = {
  __typename?: 'ProjectStatByHour';
  completedTasksCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  inAuditTasksCount: Scalars['Int'];
  newTasksCount: Scalars['Int'];
  readyForAuditTasksCount: Scalars['Int'];
  rejectedTasksCount: Scalars['Int'];
  returnedTasksCount: Scalars['Int'];
  startedTasksCount: Scalars['Int'];
  totalTasksCount: Scalars['Int'];
};

export enum ProjectStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InProcess = 'IN_PROCESS',
  Unreviewed = 'UNREVIEWED'
}

export type ProjectStatusChange = {
  __typename?: 'ProjectStatusChange';
  clientId: Scalars['Int'];
  id: Scalars['ID'];
  status: Scalars['String'];
};

export type ProjectUpdateAuditorsInput = {
  assignedAuditorIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId: Scalars['Int'];
};

export type ProjectUpdateFilesInput = {
  adminInstructionUrl?: InputMaybe<Array<Scalars['String']>>;
  clientInstructionUrl?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['Int'];
};

export type ProjectUpdateHelpersInput = {
  assignedHelperIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId: Scalars['Int'];
};

export type ProjectUpdateInfoInput = {
  adminShortInstruction?: InputMaybe<Scalars['String']>;
  clientShortInstruction?: InputMaybe<Scalars['String']>;
  customLabels?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mlLabels?: InputMaybe<MlInput>;
  projectId: Scalars['Int'];
  projectSettings?: InputMaybe<IProjectSettings>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProjectUpdateInput = {
  adminInstructionFileName?: InputMaybe<Scalars['String']>;
  adminShortInstruction?: InputMaybe<Scalars['String']>;
  assignedAuditorIds?: InputMaybe<Array<Scalars['Int']>>;
  assignedHelperIds?: InputMaybe<Array<Scalars['Int']>>;
  auditorRate?: InputMaybe<Scalars['Int']>;
  clientInstructionFileNames?: InputMaybe<Array<Scalars['String']>>;
  clientShortInstruction?: InputMaybe<Scalars['String']>;
  customLabels?: InputMaybe<Scalars['Boolean']>;
  helperRate?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mediaFileName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mlLabels?: InputMaybe<MlInput>;
  projectId: Scalars['Int'];
  projectSettings?: InputMaybe<IProjectSettings>;
  status?: InputMaybe<ProjectStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProjectUpdateRateInput = {
  auditorRate?: InputMaybe<Scalars['Int']>;
  helperRate?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
};

export type ProjectUpdateStatusInput = {
  projectId: Scalars['Int'];
  status: ProjectStatus;
};

export type ProjectsList = {
  __typename?: 'ProjectsList';
  pagesCount: Scalars['Int'];
  projects?: Maybe<Array<Maybe<Project>>>;
};

export type Query = {
  __typename?: 'Query';
  assignedProjectTitlesToHelper: Array<Maybe<Scalars['String']>>;
  clientProjectsReport?: Maybe<ClientProjectsReport>;
  generateCoCoReport: Scalars['String'];
  generateYoloReport: Scalars['String'];
  getClientProfile: ClientProfileData;
  getHelperStatistic?: Maybe<HelperAllTimeStatistic>;
  getLearningMaterialsStructure?: Maybe<LearningMaterialStructure>;
  getLearningProgress?: Maybe<Array<Maybe<TopicProgress>>>;
  getLessonLearningMaterial?: Maybe<LessonLearningMaterial>;
  getListOfHelpers?: Maybe<ClientListOfHelpers>;
  helper: Helper;
  helpers?: Maybe<HelpersList>;
  helpersStats?: Maybe<HelperReport>;
  helpersStatsByProject?: Maybe<HelperStatsReport>;
  listClients?: Maybe<ClientsList>;
  listProjects?: Maybe<ProjectsList>;
  listUnreviewedProjects?: Maybe<ProjectsList>;
  project: Project;
  projectAssets: ProjectAssets;
  projectResults: ProjectResult;
  projectTitleIsUnique?: Maybe<Scalars['Boolean']>;
  startPracticSession?: Maybe<LessonPracticeSessionInfo>;
  task: Task;
  taskList?: Maybe<Array<TaskList>>;
  test?: Maybe<Scalars['Float']>;
};


export type QueryAssignedProjectTitlesToHelperArgs = {
  helperId: Scalars['Int'];
};


export type QueryClientProjectsReportArgs = {
  clientId: Scalars['Int'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  projectId?: InputMaybe<Scalars['Int']>;
  responseFormat: ResponseFormat;
};


export type QueryGenerateCoCoReportArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type QueryGenerateYoloReportArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type QueryGetLessonLearningMaterialArgs = {
  helperId?: InputMaybe<Scalars['Int']>;
  lessonId: Scalars['Int'];
  topicId: Scalars['Int'];
};


export type QueryGetListOfHelpersArgs = {
  projectId?: InputMaybe<Scalars['Int']>;
};


export type QueryHelperArgs = {
  helperId: Scalars['Int'];
};


export type QueryHelpersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  returnAllData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHelpersStatsArgs = {
  helperId?: InputMaybe<Scalars['Int']>;
  responseFormat: ResponseFormat;
};


export type QueryHelpersStatsByProjectArgs = {
  projectId: Scalars['Int'];
  responseFormat: ResponseFormat;
};


export type QueryListClientsArgs = {
  helperId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  returnAllData?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListProjectsArgs = {
  clientId?: InputMaybe<Scalars['Int']>;
  isReadyForReport?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  returnAllData?: InputMaybe<Scalars['Boolean']>;
  sortByDateOrder?: InputMaybe<SortByDateOrder>;
};


export type QueryListUnreviewedProjectsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  sortByDateOrder?: InputMaybe<SortByDateOrder>;
};


export type QueryProjectArgs = {
  projectId: Scalars['Int'];
};


export type QueryProjectAssetsArgs = {
  projectId: Scalars['Int'];
};


export type QueryProjectResultsArgs = {
  projectId: Scalars['Int'];
  uploadToGDrive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProjectTitleIsUniqueArgs = {
  clientId: Scalars['Int'];
  title: Scalars['String'];
};


export type QueryStartPracticSessionArgs = {
  lessonId: Scalars['Int'];
  practiceId: Scalars['Int'];
  topicId: Scalars['Int'];
};


export type QueryTaskArgs = {
  taskId: Scalars['Int'];
};


export type QueryTaskListArgs = {
  projectId: Scalars['Int'];
};

export type RequestPasswordResetResult = {
  __typename?: 'RequestPasswordResetResult';
  requested: Scalars['Boolean'];
};

export enum ResponseFormat {
  Csv = 'CSV',
  Json = 'JSON'
}

export type SaveProjectResult = {
  __typename?: 'SaveProjectResult';
  id: Scalars['Int'];
};

export enum SortByDateOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SubmitTaskResult = {
  __typename?: 'SubmitTaskResult';
  newTask?: Maybe<Task>;
  processedTask: Task;
};

export type Task = {
  __typename?: 'Task';
  auditorId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  customLabels: Scalars['Boolean'];
  helperId?: Maybe<Scalars['Int']>;
  helperTimeSpent?: Maybe<Scalars['Int']>;
  history?: Maybe<Array<TaskHistory>>;
  id: Scalars['Int'];
  isAvailableForHelper?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Array<Scalars['String']>>;
  mediaUrl?: Maybe<Scalars['String']>;
  project: Project;
  projectId: Scalars['Int'];
  result?: Maybe<Scalars['JSONObject']>;
  returnedFromAuditor?: Maybe<Scalars['Boolean']>;
  status: TaskStatus;
  timesReturnedFromAuditor?: Maybe<Scalars['Int']>;
  type: TaskType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  videoChunkLength?: Maybe<Scalars['Float']>;
  videoEnd?: Maybe<Scalars['Float']>;
  videoFPS?: Maybe<Scalars['Float']>;
  videoFrameCount?: Maybe<Scalars['Float']>;
  videoStart?: Maybe<Scalars['Float']>;
  workPoints: Scalars['Int'];
};

export enum TaskAction {
  Approve = 'APPROVE',
  ApproveWithPenalty = 'APPROVE_WITH_PENALTY',
  Reject = 'REJECT',
  RejectAsAuditor = 'REJECT_AS_AUDITOR',
  Return = 'RETURN',
  Skip = 'SKIP',
  Submit = 'SUBMIT'
}

export type TaskHistory = {
  __typename?: 'TaskHistory';
  action: Scalars['String'];
  actionWasTakenAt: Scalars['DateTime'];
  comment?: Maybe<Scalars['String']>;
  initiator?: Maybe<Helper>;
};

export type TaskList = {
  __typename?: 'TaskList';
  isAvailable: Scalars['Boolean'];
  mediaURL: Scalars['String'];
  taskId: Scalars['Int'];
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  InAudit = 'IN_AUDIT',
  New = 'NEW',
  ReadyForAudit = 'READY_FOR_AUDIT',
  Rejected = 'REJECTED',
  Started = 'STARTED'
}

export enum TaskSystemAction {
  Approve = 'APPROVE',
  ApproveWithPenalty = 'APPROVE_WITH_PENALTY',
  Audit = 'AUDIT',
  Create = 'CREATE',
  Reject = 'REJECT',
  Return = 'RETURN',
  Skip = 'SKIP',
  Start = 'START',
  Submit = 'SUBMIT'
}

export enum TaskType {
  Categorization = 'CATEGORIZATION',
  ContentModeration = 'CONTENT_MODERATION',
  DataSetCollection = 'DATA_SET_COLLECTION',
  Digitization = 'DIGITIZATION',
  ImageAnnotation = 'IMAGE_ANNOTATION',
  Nlp = 'NLP',
  PhoneCall = 'PHONE_CALL',
  VideoAnnotation = 'VIDEO_ANNOTATION'
}

export type TopProject = {
  __typename?: 'TopProject';
  count: Scalars['Int'];
  type: Scalars['String'];
};

export type TopicProgress = {
  __typename?: 'TopicProgress';
  id: Scalars['Int'];
  lessons?: Maybe<Array<Maybe<LessonProgress>>>;
};

export type UploadResult = {
  __typename?: 'UploadResult';
  fname: Scalars['String'];
};

export type BulkUpdateTasksResult = {
  __typename?: 'bulkUpdateTasksResult';
  updatedTasksCount: Scalars['Int'];
};

export type ProjectResult = {
  __typename?: 'projectResult';
  id: Scalars['Int'];
  results?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
};

export type UserDeactivatedResult = {
  __typename?: 'userDeactivatedResult';
  id: Scalars['ID'];
};

export type GetProjectDetailsChartDataQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type GetProjectDetailsChartDataQuery = { __typename?: 'Query', project: { __typename?: 'Project', title: string, id: number, status: ProjectStatus, auditorsCount?: number | null, helpersCount?: number | null, createdAt: any, projectStats?: Array<{ __typename?: 'ProjectStatByHour', completedTasksCount: number, createdAt: any, inAuditTasksCount: number, newTasksCount: number, rejectedTasksCount: number, startedTasksCount: number, totalTasksCount: number, readyForAuditTasksCount: number } | null> | null } };

export type GetHelperPerformanceDataQueryVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type GetHelperPerformanceDataQuery = { __typename?: 'Query', helper: { __typename?: 'Helper', projectsCountAsAuditor?: number | null, projectsCountAsHelper?: number | null, totalProjectsCount?: number | null, penaltyRateAsAuditor?: number | null, penaltyRateAsHelper?: number | null, returnRateAsAuditor?: number | null, returnRateAsHelper?: number | null, topProjects?: Array<{ __typename?: 'TopProject', type: string, count: number }> | null } };

export type GetHelperPersonalDataQueryVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type GetHelperPersonalDataQuery = { __typename?: 'Query', helper: { __typename?: 'Helper', createdAt: any, lastLoginAt?: any | null, activatedAt?: any | null, invitedBy?: string | null } };

export type GetHelperStatisticsDataQueryVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type GetHelperStatisticsDataQuery = { __typename?: 'Query', helpersStats?: { __typename?: 'HelperReport', JSON?: Array<{ __typename?: 'HelperReportEntity', auditorPoints: number, auditorRate: number, auditorTasks: number, createdAt: any, finishedAt?: any | null, helperPoints: number, helperPointsWithPenalties: number, helperRate: number, penalties: number, title: string, totalEarned: number } | null> | null } | null };

export type GetProjectAssetsQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type GetProjectAssetsQuery = { __typename?: 'Query', projectAssets: { __typename?: 'ProjectAssets', assets: Array<string> } };

export type HelperCurrentTasksStateReportQueryVariables = Exact<{ [key: string]: never; }>;


export type HelperCurrentTasksStateReportQuery = { __typename?: 'Query', helpersStats?: { __typename?: 'HelperReport', JSON?: Array<{ __typename?: 'HelperReportEntity', title: string, penalties: number, helperRate: number, auditorRate: number, helperPoints: number, auditorTasks: number, auditorPoints: number, helperPointsWithPenalties: number, totalEarned: number, createdAt: any, finishedAt?: any | null } | null> | null } | null };

export type ClientDetailsFieldsFragment = { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any };

export type ProjectDetailFieldsFragment = { __typename?: 'Project', id: number, title: string, type: TaskType, createdAt: any, updatedAt?: any | null, isDeleted: boolean, labels?: Array<string> | null, helperRate?: number | null, auditorRate?: number | null, workPoints: number, status: ProjectStatus, platform: Platform, customLabels: boolean, helpersCount?: number | null, auditorsCount?: number | null, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, clientInstructionUrl?: Array<string | null> | null, clientShortInstruction?: string | null, mediaFileName?: Array<string | null> | null, cost?: number | null, inAuditTasksCount?: number | null, totalTasksCount?: number | null, completedTasksCount?: number | null, isUserHelper: boolean, isUserAuditor: boolean, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, projectStats?: Array<{ __typename?: 'ProjectStatByHour', createdAt: any, completedTasksCount: number, inAuditTasksCount: number, newTasksCount: number, rejectedTasksCount: number, returnedTasksCount: number, startedTasksCount: number, totalTasksCount: number, readyForAuditTasksCount: number } | null> | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null };

export type TaskFieldsFragment = { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } };

export type TaskProjectFieldsFragment = { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null };

export type TaskFragmentFieldsFragment = { __typename?: 'TaskList', taskId: number, mediaURL: string, isAvailable: boolean };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
  role: AccountType;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', RequestPasswordReset: { __typename?: 'RequestPasswordResetResult', requested: boolean } };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String'];
  new_password: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', PasswordReset: { __typename?: 'PasswordResetResult', reseted: boolean, firstName?: string | null } };

export type LoginHelperMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginHelperMutation = { __typename?: 'Mutation', loginHelper: { __typename?: 'LoginResponseHelper', token?: string | null, helper?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, email: string, enabled: boolean, isDeleted: boolean, activated: boolean } | null } };

export type LoginClientMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginClientMutation = { __typename?: 'Mutation', loginClient: { __typename?: 'LoginResponseClient', token?: string | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } };

export type LoginClientByGoogleMutationVariables = Exact<{
  googleToken: Scalars['String'];
}>;


export type LoginClientByGoogleMutation = { __typename?: 'Mutation', loginClientByGoogle: { __typename?: 'LoginResponseClient', token?: string | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } };

export type LoginAdminMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginAdminMutation = { __typename?: 'Mutation', loginAdmin: { __typename?: 'LoginResponseAdmin', token?: string | null, admin?: { __typename?: 'Admin', id: string, firstName: string, lastName: string, email: string } | null } };

export type ActivateAccountMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ActivateAccountMutation = { __typename?: 'Mutation', ActivateAccountByToken: { __typename?: 'ActivateAccountResult', activated: boolean } };

export type RegisterClientMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  companyName: Scalars['String'];
  termsVersion: Scalars['String'];
}>;


export type RegisterClientMutation = { __typename?: 'Mutation', registerClient: { __typename?: 'LoginResponseClient', token?: string | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } };

export type RegisterHelperMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type RegisterHelperMutation = { __typename?: 'Mutation', registerHelper: { __typename?: 'Helper', id: string, firstName: string, lastName: string, email: string } };

export type ResendActivationLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendActivationLinkMutation = { __typename?: 'Mutation', reSendActivationLink: boolean };

export type DeleteClientMutationVariables = Exact<{
  clientId: Scalars['Int'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: { __typename?: 'Client', id: string } };

export type CreateClientMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  companyName: Scalars['String'];
  sendInvite: Scalars['Boolean'];
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string } };

export type UpdateClientsMutationVariables = Exact<{
  clientId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  companyName: Scalars['String'];
}>;


export type UpdateClientsMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string } };

export type UpdateClientInfoMutationVariables = Exact<{
  clientId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type UpdateClientInfoMutation = { __typename?: 'Mutation', updateClientInfo: { __typename?: 'Client', id: string, firstName: string, lastName: string } };

export type ChangePasswordMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', ChangePassword: { __typename?: 'Client', id: string } };

export type ToggleClientAccountMutationVariables = Exact<{
  clientId: Scalars['Int'];
}>;


export type ToggleClientAccountMutation = { __typename?: 'Mutation', ToggleAccount: boolean };

export type SendClientActivationLinkMutationVariables = Exact<{
  clientId: Scalars['Int'];
}>;


export type SendClientActivationLinkMutation = { __typename?: 'Mutation', sendClientActivationLink?: boolean | null };

export type UpgradePricingPlanMutationVariables = Exact<{
  clientId: Scalars['Int'];
}>;


export type UpgradePricingPlanMutation = { __typename?: 'Mutation', upgradeClientPlan: boolean };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', CreateProject: { __typename?: 'SaveProjectResult', id: number } };

export type CreateVideoProjectMutationVariables = Exact<{
  input: CreateVideoAnnotationProjectInput;
}>;


export type CreateVideoProjectMutation = { __typename?: 'Mutation', CreateVideoAnnotationProject: { __typename?: 'SaveProjectResult', id: number } };

export type CreateMultiImageProjectMutationVariables = Exact<{
  input?: InputMaybe<CreateProjectInput>;
}>;


export type CreateMultiImageProjectMutation = { __typename?: 'Mutation', createMultiImageProject: { __typename?: 'SaveProjectResult', id: number } };

export type UploadInstructionFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadInstructionFileMutation = { __typename?: 'Mutation', projectAdminInstructionUpload: { __typename?: 'UploadResult', fname: string } };

export type UploadClientInstructionFilesMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadClientInstructionFilesMutation = { __typename?: 'Mutation', projectClientInstructionUpload: { __typename?: 'UploadResult', fname: string } };

export type CreateGoogleDriveProjectMutationVariables = Exact<{
  input?: InputMaybe<CreateProjectInput>;
}>;


export type CreateGoogleDriveProjectMutation = { __typename?: 'Mutation', createGoogleDriveProject: { __typename?: 'SaveProjectResult', id: number } };

export type SaveDraftProjectMutationVariables = Exact<{
  input?: InputMaybe<DraftCreateProjectInput>;
}>;


export type SaveDraftProjectMutation = { __typename?: 'Mutation', saveDraftProject: { __typename?: 'SaveProjectResult', id: number } };

export type SendRequestToHelperMutationVariables = Exact<{
  email: Scalars['String'];
  projectId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type SendRequestToHelperMutation = { __typename?: 'Mutation', sendRequestToHelper: boolean };

export type RequestHelpersMutationVariables = Exact<{
  comment: Scalars['String'];
  projectId: Scalars['Int'];
}>;


export type RequestHelpersMutation = { __typename?: 'Mutation', requestHelpers: number };

export type ProjectMediaUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
  clientId?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectMediaUploadMutation = { __typename?: 'Mutation', projectMediaUpload?: Array<string> | null };

export type DeleteHelperMutationVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type DeleteHelperMutation = { __typename?: 'Mutation', deleteHelper: { __typename?: 'Helper', id: string } };

export type CreateHelperMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type CreateHelperMutation = { __typename?: 'Mutation', createHelper: { __typename?: 'Helper', id: string } };

export type UpdateHelperMutationVariables = Exact<{
  helperId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type UpdateHelperMutation = { __typename?: 'Mutation', updateHelper: { __typename?: 'Helper', id: string } };

export type ToggleHelperAccountMutationVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type ToggleHelperAccountMutation = { __typename?: 'Mutation', ToggleAccount: boolean };

export type AcceptInviteByHelperMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AcceptInviteByHelperMutation = { __typename?: 'Mutation', acceptInviteByHelper: boolean };

export type SaveLearningProgressMutationVariables = Exact<{
  topic: Scalars['Int'];
  lesson: Scalars['Int'];
}>;


export type SaveLearningProgressMutation = { __typename?: 'Mutation', saveLearningProgress?: Array<{ __typename?: 'TopicProgress', id: number } | null> | null };

export type SubmitLessonPracticeMutationVariables = Exact<{
  topicId: Scalars['Int'];
  lessonId: Scalars['Int'];
  practiceId: Scalars['Int'];
  result: Scalars['JSONObject'];
}>;


export type SubmitLessonPracticeMutation = { __typename?: 'Mutation', submitLessonPractice?: { __typename?: 'LessonPracticeTaskSubmit', result?: number | null, totalSessionSize?: number | null, currentTaskIndex?: number | null, next?: { __typename?: 'LessonPracticeTask', type: TaskType, mediaFileName?: string | null, labels?: Array<string> | null, mediaUrl?: string | null, videoChunkLength?: number | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, settings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null } | null } | null } | null };

export type ArchiveProjectMutationVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject: boolean };

export type UpdateProjectMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateInput>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: number } };

export type ProjectUpdateStatusMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateStatusInput>;
}>;


export type ProjectUpdateStatusMutation = { __typename?: 'Mutation', updateStatus: { __typename?: 'Project', id: number } };

export type ProjectUpdateInfoMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateInfoInput>;
}>;


export type ProjectUpdateInfoMutation = { __typename?: 'Mutation', updateInfo: { __typename?: 'Project', id: number } };

export type ProjectUpdateRateMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateRateInput>;
}>;


export type ProjectUpdateRateMutation = { __typename?: 'Mutation', updateRate: { __typename?: 'Project', id: number } };

export type ProjectUpdateFilesMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateFilesInput>;
}>;


export type ProjectUpdateFilesMutation = { __typename?: 'Mutation', updateFiles: { __typename?: 'Project', id: number } };

export type ProjectUpdateAssignedHelperMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateHelpersInput>;
}>;


export type ProjectUpdateAssignedHelperMutation = { __typename?: 'Mutation', updateAssignedHelper: { __typename?: 'Project', id: number } };

export type ProjectUpdateAssignedAuditorMutationVariables = Exact<{
  input?: InputMaybe<ProjectUpdateAuditorsInput>;
}>;


export type ProjectUpdateAssignedAuditorMutation = { __typename?: 'Mutation', updateAssignedAuditor: { __typename?: 'Project', id: number } };

export type UploadOverrideZipMutationVariables = Exact<{
  fileName: Scalars['String'];
  projectId: Scalars['Int'];
}>;


export type UploadOverrideZipMutation = { __typename?: 'Mutation', projectOverwriteTasks: boolean };

export type CopyProjectMutationVariables = Exact<{
  projectId: Scalars['Int'];
  newTitle: Scalars['String'];
}>;


export type CopyProjectMutation = { __typename?: 'Mutation', copyProject: { __typename?: 'SaveProjectResult', id: number } };

export type UpdateTaskByIdMutationVariables = Exact<{
  toStatus?: InputMaybe<TaskStatus>;
  fromStatus?: InputMaybe<TaskStatus>;
  toHelperId?: InputMaybe<Scalars['Int']>;
  fromHelperId?: InputMaybe<Scalars['Int']>;
  toAuditorId?: InputMaybe<Scalars['Int']>;
  fromAuditorId?: InputMaybe<Scalars['Int']>;
  taskId: Scalars['Int'];
}>;


export type UpdateTaskByIdMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: number } };

export type UpdateTasksByProjectIdMutationVariables = Exact<{
  toStatus?: InputMaybe<TaskStatus>;
  fromStatus?: InputMaybe<TaskStatus>;
  toHelperId?: InputMaybe<Scalars['Int']>;
  fromHelperId?: InputMaybe<Scalars['Int']>;
  toAuditorId?: InputMaybe<Scalars['Int']>;
  fromAuditorId?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
}>;


export type UpdateTasksByProjectIdMutation = { __typename?: 'Mutation', bulkUpdateTasks: { __typename?: 'bulkUpdateTasksResult', updatedTasksCount: number } };

export type StartTaskingMutationVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type StartTaskingMutation = { __typename?: 'Mutation', startTasking: { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } } };

export type StartAuditingMutationVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type StartAuditingMutation = { __typename?: 'Mutation', startAuditing: { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } } };

export type SubmitTaskMutationVariables = Exact<{
  action: TaskAction;
  taskId: Scalars['Int'];
  result?: InputMaybe<Scalars['JSONObject']>;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type SubmitTaskMutation = { __typename?: 'Mutation', submitTask: { __typename?: 'SubmitTaskResult', newTask?: { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } } | null, processedTask: { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } } } };

export type AutosaveTaskMutationVariables = Exact<{
  result?: InputMaybe<Scalars['JSONObject']>;
  taskId: Scalars['Int'];
}>;


export type AutosaveTaskMutation = { __typename?: 'Mutation', autosaveTask: { __typename?: 'Task', id: number } };

export type UpdateTaskMutationVariables = Exact<{
  fromAuditorId?: InputMaybe<Scalars['Int']>;
  fromHelperId?: InputMaybe<Scalars['Int']>;
  fromStatus?: InputMaybe<TaskStatus>;
  taskId: Scalars['Int'];
  toAuditorId?: InputMaybe<Scalars['Int']>;
  toHelperId?: InputMaybe<Scalars['Int']>;
  toStatus?: InputMaybe<TaskStatus>;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: number, auditorId?: number | null, helperId?: number | null, projectId: number } };

export type SelectTaskMutationVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type SelectTaskMutation = { __typename?: 'Mutation', selectTask?: { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } } | null };

export type ListClientsQueryVariables = Exact<{
  helperId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  returnAllData?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListClientsQuery = { __typename?: 'Query', listClients?: { __typename?: 'ClientsList', pagesCount: number, clients?: Array<{ __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null> | null } | null };

export type ClientCurrentTasksStateReportQueryVariables = Exact<{
  clientId: Scalars['Int'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  projectId?: InputMaybe<Scalars['Int']>;
}>;


export type ClientCurrentTasksStateReportQuery = { __typename?: 'Query', clientProjectsReport?: { __typename?: 'ClientProjectsReport', JSON?: Array<{ __typename?: 'Project', helperRate?: number | null, id: number, labels?: Array<string> | null, newTasksCount?: number | null, startedTasksCount?: number | null, inAuditTasksCount?: number | null, rejectedTasksCount?: number | null, completedTasksCount?: number | null, totalTasksCount?: number | null, title: string, type: TaskType, auditorRate?: number | null, auditorsCount?: number | null, workPoints: number, updatedAt?: any | null, createdAt: any, client?: { __typename?: 'Client', companyName?: string | null } | null } | null> | null } | null };

export type ClientCurrentTasksStateReportCsvQueryVariables = Exact<{
  clientId: Scalars['Int'];
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  projectId?: InputMaybe<Scalars['Int']>;
}>;


export type ClientCurrentTasksStateReportCsvQuery = { __typename?: 'Query', clientProjectsReport?: { __typename?: 'ClientProjectsReport', CSV?: string | null } | null };

export type HelpersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  returnAllData?: InputMaybe<Scalars['Boolean']>;
}>;


export type HelpersQuery = { __typename?: 'Query', helpers?: { __typename?: 'HelpersList', pagesCount: number, helpers?: Array<{ __typename?: 'Helper', activated: boolean, email: string, firstName: string, id: string, isDeleted: boolean, lastName: string, enabled: boolean, assignedToProjectAsAuditor?: boolean | null, assignedToProjectAsHelper?: boolean | null } | null> | null } | null };

export type GetHelperByIdQueryVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type GetHelperByIdQuery = { __typename?: 'Query', helper: { __typename?: 'Helper', assignedToProjectAsAuditor?: boolean | null, assignedToProjectAsHelper?: boolean | null, activated: boolean, email: string, enabled: boolean, firstName: string, id: string, isDeleted: boolean, lastName: string } };

export type GetAssignedHelpersListQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['Int']>;
}>;


export type GetAssignedHelpersListQuery = { __typename?: 'Query', helpers?: { __typename?: 'HelpersList', pagesCount: number, helpers?: Array<{ __typename?: 'Helper', activated: boolean, email: string, firstName: string, id: string, isDeleted: boolean, lastName: string, enabled: boolean, assignedToProjectAsAuditor?: boolean | null, assignedToProjectAsHelper?: boolean | null } | null> | null } | null };

export type ReportsGetHelpersStatsByPrjIdQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ReportsGetHelpersStatsByPrjIdQuery = { __typename?: 'Query', helpersStatsByProject?: { __typename?: 'HelperStatsReport', CSV?: string | null, JSON?: Array<{ __typename?: 'HelperStats', firstName: string, helperPoints: number, helperRate: number, auditorPoints: number, id: string, auditorRate: number, lastName: string, penalties: number, auditorTasksCount?: number | null } | null> | null } | null };

export type ReportsGetHelpersStatsByPrjIdCsvQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ReportsGetHelpersStatsByPrjIdCsvQuery = { __typename?: 'Query', helpersStatsByProject?: { __typename?: 'HelperStatsReport', CSV?: string | null } | null };

export type GetListOfHelpersQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['Int']>;
}>;


export type GetListOfHelpersQuery = { __typename?: 'Query', getListOfHelpers?: { __typename?: 'ClientListOfHelpers', invited: Array<{ __typename?: 'Helper', lastName: string, firstName: string, email: string } | null>, requested: Array<{ __typename?: 'Helper', lastName: string, firstName: string, email: string } | null>, pending: Array<{ __typename?: 'Helper', lastName: string, firstName: string, email: string } | null> } | null };

export type GetLearningProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLearningProgressQuery = { __typename?: 'Query', getLearningProgress?: Array<{ __typename?: 'TopicProgress', id: number, lessons?: Array<{ __typename?: 'LessonProgress', id: number } | null> | null } | null> | null };

export type GetAllTimeStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTimeStatsQuery = { __typename?: 'Query', getHelperStatistic?: { __typename?: 'HelperAllTimeStatistic', projectDone: number, taskCompleted: number, taskReturned: number, totalEarned: number, dailyStat: { __typename?: 'HelperBaseStatistic', projectDone: number, taskCompleted: number, taskReturned: number, totalEarned: number } } | null };

export type GetLearningMaterialsStructureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLearningMaterialsStructureQuery = { __typename?: 'Query', getLearningMaterialsStructure?: { __typename?: 'LearningMaterialStructure', topics?: Array<{ __typename?: 'LearningMaterialTopicStructure', id: number, title: string, lessons?: Array<{ __typename?: 'LearningMaterialTopicLessonsStructure', id: number, title: string, isDone: boolean } | null> | null } | null> | null } | null };

export type GetLessonLearningMaterialQueryVariables = Exact<{
  helperId: Scalars['Int'];
  lessonId: Scalars['Int'];
  topicId: Scalars['Int'];
}>;


export type GetLessonLearningMaterialQuery = { __typename?: 'Query', getLessonLearningMaterial?: { __typename?: 'LessonLearningMaterial', description: string, images?: Array<string | null> | null, practice?: Array<{ __typename?: 'LessonLearningMaterialPractice', id: number, title: string, avgResult: number } | null> | null } | null };

export type StartPracticeSessionQueryVariables = Exact<{
  lessonId: Scalars['Int'];
  practiceId: Scalars['Int'];
  topicId: Scalars['Int'];
}>;


export type StartPracticeSessionQuery = { __typename?: 'Query', startPracticSession?: { __typename?: 'LessonPracticeSessionInfo', sessionEndDate?: any | null, totalSessionSize?: number | null, task?: { __typename?: 'LessonPracticeTask', type: TaskType, mediaFileName?: string | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, settings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null } | null } | null } | null };

export type GetProjectQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: number, title: string, type: TaskType, createdAt: any, updatedAt?: any | null, isDeleted: boolean, labels?: Array<string> | null, helperRate?: number | null, auditorRate?: number | null, workPoints: number, status: ProjectStatus, platform: Platform, customLabels: boolean, helpersCount?: number | null, auditorsCount?: number | null, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, clientInstructionUrl?: Array<string | null> | null, clientShortInstruction?: string | null, mediaFileName?: Array<string | null> | null, cost?: number | null, inAuditTasksCount?: number | null, totalTasksCount?: number | null, completedTasksCount?: number | null, isUserHelper: boolean, isUserAuditor: boolean, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, projectStats?: Array<{ __typename?: 'ProjectStatByHour', createdAt: any, completedTasksCount: number, inAuditTasksCount: number, newTasksCount: number, rejectedTasksCount: number, returnedTasksCount: number, startedTasksCount: number, totalTasksCount: number, readyForAuditTasksCount: number } | null> | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } };

export type ProjectResultsQueryVariables = Exact<{
  uploadToGDrive?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
}>;


export type ProjectResultsQuery = { __typename?: 'Query', projectResults: { __typename?: 'projectResult', id: number, results?: Array<any | null> | null } };

export type ListProjectsQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']>;
  sortByDateOrder?: InputMaybe<SortByDateOrder>;
  page?: InputMaybe<Scalars['Int']>;
  returnAllData?: InputMaybe<Scalars['Boolean']>;
  isReadyForReport?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListProjectsQuery = { __typename?: 'Query', listProjects?: { __typename?: 'ProjectsList', pagesCount: number, projects?: Array<{ __typename?: 'Project', id: number, title: string, type: TaskType, createdAt: any, updatedAt?: any | null, isDeleted: boolean, labels?: Array<string> | null, helperRate?: number | null, auditorRate?: number | null, workPoints: number, status: ProjectStatus, platform: Platform, customLabels: boolean, helpersCount?: number | null, auditorsCount?: number | null, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, clientInstructionUrl?: Array<string | null> | null, clientShortInstruction?: string | null, mediaFileName?: Array<string | null> | null, cost?: number | null, inAuditTasksCount?: number | null, totalTasksCount?: number | null, completedTasksCount?: number | null, isUserHelper: boolean, isUserAuditor: boolean, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, projectStats?: Array<{ __typename?: 'ProjectStatByHour', createdAt: any, completedTasksCount: number, inAuditTasksCount: number, newTasksCount: number, rejectedTasksCount: number, returnedTasksCount: number, startedTasksCount: number, totalTasksCount: number, readyForAuditTasksCount: number } | null> | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } | null> | null } | null };

export type ListUnreviewdProjectsQueryVariables = Exact<{
  sortByDateOrder?: InputMaybe<SortByDateOrder>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type ListUnreviewdProjectsQuery = { __typename?: 'Query', listUnreviewedProjects?: { __typename?: 'ProjectsList', pagesCount: number, projects?: Array<{ __typename?: 'Project', id: number, title: string, type: TaskType, createdAt: any, updatedAt?: any | null, isDeleted: boolean, labels?: Array<string> | null, helperRate?: number | null, auditorRate?: number | null, workPoints: number, status: ProjectStatus, platform: Platform, customLabels: boolean, helpersCount?: number | null, auditorsCount?: number | null, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, clientInstructionUrl?: Array<string | null> | null, clientShortInstruction?: string | null, mediaFileName?: Array<string | null> | null, cost?: number | null, inAuditTasksCount?: number | null, totalTasksCount?: number | null, completedTasksCount?: number | null, isUserHelper: boolean, isUserAuditor: boolean, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, projectStats?: Array<{ __typename?: 'ProjectStatByHour', createdAt: any, completedTasksCount: number, inAuditTasksCount: number, newTasksCount: number, rejectedTasksCount: number, returnedTasksCount: number, startedTasksCount: number, totalTasksCount: number, readyForAuditTasksCount: number } | null> | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } | null> | null } | null };

export type GetProjectByIdQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type GetProjectByIdQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: number, title: string, type: TaskType, createdAt: any, updatedAt?: any | null, isDeleted: boolean, labels?: Array<string> | null, helperRate?: number | null, auditorRate?: number | null, workPoints: number, status: ProjectStatus, platform: Platform, customLabels: boolean, helpersCount?: number | null, auditorsCount?: number | null, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, clientInstructionUrl?: Array<string | null> | null, clientShortInstruction?: string | null, mediaFileName?: Array<string | null> | null, cost?: number | null, inAuditTasksCount?: number | null, totalTasksCount?: number | null, completedTasksCount?: number | null, isUserHelper: boolean, isUserAuditor: boolean, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, projectStats?: Array<{ __typename?: 'ProjectStatByHour', createdAt: any, completedTasksCount: number, inAuditTasksCount: number, newTasksCount: number, rejectedTasksCount: number, returnedTasksCount: number, startedTasksCount: number, totalTasksCount: number, readyForAuditTasksCount: number } | null> | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', id: string, firstName: string, lastName: string, email: string, activated: boolean, isDeleted: boolean, enabled: boolean, companyName?: string | null, isPremium: boolean, createdAt: any } | null } };

export type AssignedProjectTitlesToHelperQueryVariables = Exact<{
  helperId: Scalars['Int'];
}>;


export type AssignedProjectTitlesToHelperQuery = { __typename?: 'Query', assignedProjectTitlesToHelper: Array<string | null> };

export type ProjectTitleUniqQueryVariables = Exact<{
  clientId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type ProjectTitleUniqQuery = { __typename?: 'Query', projectTitleIsUnique?: boolean | null };

export type ProjectGenerateCocoReportQueryVariables = Exact<{
  clientId: Scalars['Int'];
  projectId: Scalars['Int'];
}>;


export type ProjectGenerateCocoReportQuery = { __typename?: 'Query', generateCoCoReport: string };

export type ProjectGenerateYoloReportQueryVariables = Exact<{
  clientId: Scalars['Int'];
  projectId: Scalars['Int'];
}>;


export type ProjectGenerateYoloReportQuery = { __typename?: 'Query', generateYoloReport: string };

export type GetTaskByIdQueryVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type GetTaskByIdQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: number, type: TaskType, createdAt: any, updatedAt?: any | null, projectId: number, result?: any | null, helperTimeSpent?: number | null, returnedFromAuditor?: boolean | null, timesReturnedFromAuditor?: number | null, status: TaskStatus, auditorId?: number | null, helperId?: number | null, mediaUrl?: string | null, labels?: Array<string> | null, videoStart?: number | null, videoEnd?: number | null, videoFPS?: number | null, videoFrameCount?: number | null, videoChunkLength?: number | null, workPoints: number, customLabels: boolean, isAvailableForHelper?: boolean | null, history?: Array<{ __typename?: 'TaskHistory', action: string, actionWasTakenAt: any, comment?: string | null, initiator?: { __typename?: 'Helper', id: string, firstName: string, lastName: string, activated: boolean, createdAt: any, email: string, enabled: boolean, isDeleted: boolean } | null }> | null, project: { __typename?: 'Project', customLabels: boolean, adminInstructionUrl?: string | null, adminShortInstruction?: string | null, id: number, title: string, type: TaskType, createdAt: any, mediaFileName?: Array<string | null> | null, updatedAt?: any | null, labels?: Array<string> | null, status: ProjectStatus, isDeleted: boolean, auditorRate?: number | null, helperRate?: number | null, workPoints: number, projectSettings?: { __typename?: 'ProjectSettings', chunkLength?: number | null, subType?: string | null, annotationType?: string | null, processingType?: string | null } | null, mlLabels?: { __typename?: 'ML', multilabels?: Array<{ __typename?: 'MLabelsType', entities: Array<string>, id: string, name: string, type: Ml_Label_Type, trigger?: { __typename?: 'MLTriggerType', items: Array<string>, parentId: string } | null }> | null } | null, client?: { __typename?: 'Client', companyName?: string | null, firstName: string, lastName: string, id: string, email: string } | null } } };

export type GetTaskListQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type GetTaskListQuery = { __typename?: 'Query', taskList?: Array<{ __typename?: 'TaskList', taskId: number, mediaURL: string, isAvailable: boolean }> | null };

export const ClientDetailsFieldsFragmentDoc = gql`
    fragment ClientDetailsFields on Client {
  id
  firstName
  lastName
  email
  activated
  isDeleted
  enabled
  companyName
  isPremium
  createdAt
}
    `;
export const ProjectDetailFieldsFragmentDoc = gql`
    fragment ProjectDetailFields on Project {
  id
  title
  type
  createdAt
  updatedAt
  isDeleted
  labels
  helperRate
  auditorRate
  workPoints
  status
  platform
  customLabels
  helpersCount
  auditorsCount
  adminInstructionUrl
  adminShortInstruction
  clientInstructionUrl
  clientShortInstruction
  mediaFileName
  cost
  projectSettings {
    chunkLength
    subType
    annotationType
    processingType
  }
  projectStats {
    createdAt
    completedTasksCount
    inAuditTasksCount
    newTasksCount
    rejectedTasksCount
    returnedTasksCount
    startedTasksCount
    totalTasksCount
    readyForAuditTasksCount
  }
  inAuditTasksCount
  totalTasksCount
  completedTasksCount
  isUserHelper
  isUserAuditor
  mlLabels {
    multilabels {
      entities
      id
      name
      trigger {
        items
        parentId
      }
      type
    }
  }
  client {
    ...ClientDetailsFields
  }
}
    ${ClientDetailsFieldsFragmentDoc}`;
export const TaskProjectFieldsFragmentDoc = gql`
    fragment TaskProjectFields on Project {
  customLabels
  adminInstructionUrl
  adminShortInstruction
  id
  title
  type
  createdAt
  mediaFileName
  updatedAt
  labels
  status
  isDeleted
  auditorRate
  helperRate
  workPoints
  projectSettings {
    chunkLength
    subType
    annotationType
    processingType
  }
  mlLabels {
    multilabels {
      entities
      id
      name
      trigger {
        items
        parentId
      }
      type
    }
  }
  client {
    companyName
    firstName
    lastName
    id
    email
  }
}
    `;
export const TaskFieldsFragmentDoc = gql`
    fragment TaskFields on Task {
  id
  type
  createdAt
  updatedAt
  projectId
  result
  helperTimeSpent
  returnedFromAuditor
  timesReturnedFromAuditor
  status
  auditorId
  helperId
  history {
    action
    actionWasTakenAt
    comment
    initiator {
      id
      firstName
      lastName
      activated
      createdAt
      email
      enabled
      isDeleted
    }
  }
  project {
    ...TaskProjectFields
  }
  mediaUrl
  labels
  videoStart
  videoEnd
  videoFPS
  videoFrameCount
  videoChunkLength
  workPoints
  customLabels
  isAvailableForHelper
}
    ${TaskProjectFieldsFragmentDoc}`;
export const TaskFragmentFieldsFragmentDoc = gql`
    fragment TaskFragmentFields on TaskList {
  taskId
  mediaURL
  isAvailable
}
    `;
export const GetProjectDetailsChartDataDocument = gql`
    query GetProjectDetailsChartData($projectId: Int!) {
  project(projectId: $projectId) {
    title
    id
    projectStats {
      completedTasksCount
      createdAt
      inAuditTasksCount
      newTasksCount
      rejectedTasksCount
      startedTasksCount
      totalTasksCount
      readyForAuditTasksCount
    }
    status
    auditorsCount
    helpersCount
    createdAt
  }
}
    `;

/**
 * __useGetProjectDetailsChartDataQuery__
 *
 * To run a query within a React component, call `useGetProjectDetailsChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDetailsChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDetailsChartDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectDetailsChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDetailsChartDataQuery, GetProjectDetailsChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDetailsChartDataQuery, GetProjectDetailsChartDataQueryVariables>(GetProjectDetailsChartDataDocument, options);
      }
export function useGetProjectDetailsChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDetailsChartDataQuery, GetProjectDetailsChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDetailsChartDataQuery, GetProjectDetailsChartDataQueryVariables>(GetProjectDetailsChartDataDocument, options);
        }
export type GetProjectDetailsChartDataQueryHookResult = ReturnType<typeof useGetProjectDetailsChartDataQuery>;
export type GetProjectDetailsChartDataLazyQueryHookResult = ReturnType<typeof useGetProjectDetailsChartDataLazyQuery>;
export type GetProjectDetailsChartDataQueryResult = Apollo.QueryResult<GetProjectDetailsChartDataQuery, GetProjectDetailsChartDataQueryVariables>;
export const GetHelperPerformanceDataDocument = gql`
    query GetHelperPerformanceData($helperId: Int!) {
  helper(helperId: $helperId) {
    projectsCountAsAuditor
    projectsCountAsHelper
    topProjects {
      type
      count
    }
    totalProjectsCount
    penaltyRateAsAuditor
    penaltyRateAsHelper
    returnRateAsAuditor
    returnRateAsHelper
  }
}
    `;

/**
 * __useGetHelperPerformanceDataQuery__
 *
 * To run a query within a React component, call `useGetHelperPerformanceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelperPerformanceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelperPerformanceDataQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useGetHelperPerformanceDataQuery(baseOptions: Apollo.QueryHookOptions<GetHelperPerformanceDataQuery, GetHelperPerformanceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelperPerformanceDataQuery, GetHelperPerformanceDataQueryVariables>(GetHelperPerformanceDataDocument, options);
      }
export function useGetHelperPerformanceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelperPerformanceDataQuery, GetHelperPerformanceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelperPerformanceDataQuery, GetHelperPerformanceDataQueryVariables>(GetHelperPerformanceDataDocument, options);
        }
export type GetHelperPerformanceDataQueryHookResult = ReturnType<typeof useGetHelperPerformanceDataQuery>;
export type GetHelperPerformanceDataLazyQueryHookResult = ReturnType<typeof useGetHelperPerformanceDataLazyQuery>;
export type GetHelperPerformanceDataQueryResult = Apollo.QueryResult<GetHelperPerformanceDataQuery, GetHelperPerformanceDataQueryVariables>;
export const GetHelperPersonalDataDocument = gql`
    query GetHelperPersonalData($helperId: Int!) {
  helper(helperId: $helperId) {
    createdAt
    lastLoginAt
    activatedAt
    invitedBy
  }
}
    `;

/**
 * __useGetHelperPersonalDataQuery__
 *
 * To run a query within a React component, call `useGetHelperPersonalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelperPersonalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelperPersonalDataQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useGetHelperPersonalDataQuery(baseOptions: Apollo.QueryHookOptions<GetHelperPersonalDataQuery, GetHelperPersonalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelperPersonalDataQuery, GetHelperPersonalDataQueryVariables>(GetHelperPersonalDataDocument, options);
      }
export function useGetHelperPersonalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelperPersonalDataQuery, GetHelperPersonalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelperPersonalDataQuery, GetHelperPersonalDataQueryVariables>(GetHelperPersonalDataDocument, options);
        }
export type GetHelperPersonalDataQueryHookResult = ReturnType<typeof useGetHelperPersonalDataQuery>;
export type GetHelperPersonalDataLazyQueryHookResult = ReturnType<typeof useGetHelperPersonalDataLazyQuery>;
export type GetHelperPersonalDataQueryResult = Apollo.QueryResult<GetHelperPersonalDataQuery, GetHelperPersonalDataQueryVariables>;
export const GetHelperStatisticsDataDocument = gql`
    query GetHelperStatisticsData($helperId: Int!) {
  helpersStats(responseFormat: JSON, helperId: $helperId) {
    JSON {
      auditorPoints
      auditorRate
      auditorTasks
      createdAt
      finishedAt
      helperPoints
      helperPointsWithPenalties
      helperRate
      penalties
      title
      totalEarned
    }
  }
}
    `;

/**
 * __useGetHelperStatisticsDataQuery__
 *
 * To run a query within a React component, call `useGetHelperStatisticsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelperStatisticsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelperStatisticsDataQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useGetHelperStatisticsDataQuery(baseOptions: Apollo.QueryHookOptions<GetHelperStatisticsDataQuery, GetHelperStatisticsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelperStatisticsDataQuery, GetHelperStatisticsDataQueryVariables>(GetHelperStatisticsDataDocument, options);
      }
export function useGetHelperStatisticsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelperStatisticsDataQuery, GetHelperStatisticsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelperStatisticsDataQuery, GetHelperStatisticsDataQueryVariables>(GetHelperStatisticsDataDocument, options);
        }
export type GetHelperStatisticsDataQueryHookResult = ReturnType<typeof useGetHelperStatisticsDataQuery>;
export type GetHelperStatisticsDataLazyQueryHookResult = ReturnType<typeof useGetHelperStatisticsDataLazyQuery>;
export type GetHelperStatisticsDataQueryResult = Apollo.QueryResult<GetHelperStatisticsDataQuery, GetHelperStatisticsDataQueryVariables>;
export const GetProjectAssetsDocument = gql`
    query GetProjectAssets($projectId: Int!) {
  projectAssets(projectId: $projectId) {
    assets
  }
}
    `;

/**
 * __useGetProjectAssetsQuery__
 *
 * To run a query within a React component, call `useGetProjectAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAssetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectAssetsQuery, GetProjectAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAssetsQuery, GetProjectAssetsQueryVariables>(GetProjectAssetsDocument, options);
      }
export function useGetProjectAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAssetsQuery, GetProjectAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAssetsQuery, GetProjectAssetsQueryVariables>(GetProjectAssetsDocument, options);
        }
export type GetProjectAssetsQueryHookResult = ReturnType<typeof useGetProjectAssetsQuery>;
export type GetProjectAssetsLazyQueryHookResult = ReturnType<typeof useGetProjectAssetsLazyQuery>;
export type GetProjectAssetsQueryResult = Apollo.QueryResult<GetProjectAssetsQuery, GetProjectAssetsQueryVariables>;
export const HelperCurrentTasksStateReportDocument = gql`
    query HelperCurrentTasksStateReport {
  helpersStats(responseFormat: JSON) {
    JSON {
      title
      penalties
      helperRate
      auditorRate
      helperPoints
      auditorTasks
      auditorPoints
      helperPointsWithPenalties
      totalEarned
      createdAt
      finishedAt
    }
  }
}
    `;

/**
 * __useHelperCurrentTasksStateReportQuery__
 *
 * To run a query within a React component, call `useHelperCurrentTasksStateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelperCurrentTasksStateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelperCurrentTasksStateReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelperCurrentTasksStateReportQuery(baseOptions?: Apollo.QueryHookOptions<HelperCurrentTasksStateReportQuery, HelperCurrentTasksStateReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelperCurrentTasksStateReportQuery, HelperCurrentTasksStateReportQueryVariables>(HelperCurrentTasksStateReportDocument, options);
      }
export function useHelperCurrentTasksStateReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelperCurrentTasksStateReportQuery, HelperCurrentTasksStateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelperCurrentTasksStateReportQuery, HelperCurrentTasksStateReportQueryVariables>(HelperCurrentTasksStateReportDocument, options);
        }
export type HelperCurrentTasksStateReportQueryHookResult = ReturnType<typeof useHelperCurrentTasksStateReportQuery>;
export type HelperCurrentTasksStateReportLazyQueryHookResult = ReturnType<typeof useHelperCurrentTasksStateReportLazyQuery>;
export type HelperCurrentTasksStateReportQueryResult = Apollo.QueryResult<HelperCurrentTasksStateReportQuery, HelperCurrentTasksStateReportQueryVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!, $role: AccountType!) {
  RequestPasswordReset(email: $email, role: $role) {
    requested
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $new_password: String!) {
  PasswordReset(token: $token, new_password: $new_password) {
    reseted
    firstName
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      new_password: // value for 'new_password'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const LoginHelperDocument = gql`
    mutation LoginHelper($email: String!, $password: String!) {
  loginHelper(email: $email, password: $password) {
    token
    helper {
      id
      firstName
      lastName
      email
      enabled
      isDeleted
      activated
    }
  }
}
    `;
export type LoginHelperMutationFn = Apollo.MutationFunction<LoginHelperMutation, LoginHelperMutationVariables>;

/**
 * __useLoginHelperMutation__
 *
 * To run a mutation, you first call `useLoginHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginHelperMutation, { data, loading, error }] = useLoginHelperMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginHelperMutation(baseOptions?: Apollo.MutationHookOptions<LoginHelperMutation, LoginHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginHelperMutation, LoginHelperMutationVariables>(LoginHelperDocument, options);
      }
export type LoginHelperMutationHookResult = ReturnType<typeof useLoginHelperMutation>;
export type LoginHelperMutationResult = Apollo.MutationResult<LoginHelperMutation>;
export type LoginHelperMutationOptions = Apollo.BaseMutationOptions<LoginHelperMutation, LoginHelperMutationVariables>;
export const LoginClientDocument = gql`
    mutation LoginClient($email: String!, $password: String!) {
  loginClient(email: $email, password: $password) {
    token
    client {
      ...ClientDetailsFields
    }
  }
}
    ${ClientDetailsFieldsFragmentDoc}`;
export type LoginClientMutationFn = Apollo.MutationFunction<LoginClientMutation, LoginClientMutationVariables>;

/**
 * __useLoginClientMutation__
 *
 * To run a mutation, you first call `useLoginClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginClientMutation, { data, loading, error }] = useLoginClientMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginClientMutation(baseOptions?: Apollo.MutationHookOptions<LoginClientMutation, LoginClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginClientMutation, LoginClientMutationVariables>(LoginClientDocument, options);
      }
export type LoginClientMutationHookResult = ReturnType<typeof useLoginClientMutation>;
export type LoginClientMutationResult = Apollo.MutationResult<LoginClientMutation>;
export type LoginClientMutationOptions = Apollo.BaseMutationOptions<LoginClientMutation, LoginClientMutationVariables>;
export const LoginClientByGoogleDocument = gql`
    mutation LoginClientByGoogle($googleToken: String!) {
  loginClientByGoogle(googleToken: $googleToken) {
    token
    client {
      ...ClientDetailsFields
    }
  }
}
    ${ClientDetailsFieldsFragmentDoc}`;
export type LoginClientByGoogleMutationFn = Apollo.MutationFunction<LoginClientByGoogleMutation, LoginClientByGoogleMutationVariables>;

/**
 * __useLoginClientByGoogleMutation__
 *
 * To run a mutation, you first call `useLoginClientByGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginClientByGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginClientByGoogleMutation, { data, loading, error }] = useLoginClientByGoogleMutation({
 *   variables: {
 *      googleToken: // value for 'googleToken'
 *   },
 * });
 */
export function useLoginClientByGoogleMutation(baseOptions?: Apollo.MutationHookOptions<LoginClientByGoogleMutation, LoginClientByGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginClientByGoogleMutation, LoginClientByGoogleMutationVariables>(LoginClientByGoogleDocument, options);
      }
export type LoginClientByGoogleMutationHookResult = ReturnType<typeof useLoginClientByGoogleMutation>;
export type LoginClientByGoogleMutationResult = Apollo.MutationResult<LoginClientByGoogleMutation>;
export type LoginClientByGoogleMutationOptions = Apollo.BaseMutationOptions<LoginClientByGoogleMutation, LoginClientByGoogleMutationVariables>;
export const LoginAdminDocument = gql`
    mutation LoginAdmin($email: String!, $password: String!) {
  loginAdmin(email: $email, password: $password) {
    token
    admin {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type LoginAdminMutationFn = Apollo.MutationFunction<LoginAdminMutation, LoginAdminMutationVariables>;

/**
 * __useLoginAdminMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutation, { data, loading, error }] = useLoginAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutation(baseOptions?: Apollo.MutationHookOptions<LoginAdminMutation, LoginAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAdminMutation, LoginAdminMutationVariables>(LoginAdminDocument, options);
      }
export type LoginAdminMutationHookResult = ReturnType<typeof useLoginAdminMutation>;
export type LoginAdminMutationResult = Apollo.MutationResult<LoginAdminMutation>;
export type LoginAdminMutationOptions = Apollo.BaseMutationOptions<LoginAdminMutation, LoginAdminMutationVariables>;
export const ActivateAccountDocument = gql`
    mutation ActivateAccount($token: String!) {
  ActivateAccountByToken(token: $token) {
    activated
  }
}
    `;
export type ActivateAccountMutationFn = Apollo.MutationFunction<ActivateAccountMutation, ActivateAccountMutationVariables>;

/**
 * __useActivateAccountMutation__
 *
 * To run a mutation, you first call `useActivateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAccountMutation, { data, loading, error }] = useActivateAccountMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useActivateAccountMutation(baseOptions?: Apollo.MutationHookOptions<ActivateAccountMutation, ActivateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateAccountMutation, ActivateAccountMutationVariables>(ActivateAccountDocument, options);
      }
export type ActivateAccountMutationHookResult = ReturnType<typeof useActivateAccountMutation>;
export type ActivateAccountMutationResult = Apollo.MutationResult<ActivateAccountMutation>;
export type ActivateAccountMutationOptions = Apollo.BaseMutationOptions<ActivateAccountMutation, ActivateAccountMutationVariables>;
export const RegisterClientDocument = gql`
    mutation RegisterClient($firstName: String!, $lastName: String!, $email: String!, $password: String!, $companyName: String!, $termsVersion: String!) {
  registerClient(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
    companyName: $companyName
    termsVersion: $termsVersion
  ) {
    token
    client {
      ...ClientDetailsFields
    }
  }
}
    ${ClientDetailsFieldsFragmentDoc}`;
export type RegisterClientMutationFn = Apollo.MutationFunction<RegisterClientMutation, RegisterClientMutationVariables>;

/**
 * __useRegisterClientMutation__
 *
 * To run a mutation, you first call `useRegisterClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerClientMutation, { data, loading, error }] = useRegisterClientMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      companyName: // value for 'companyName'
 *      termsVersion: // value for 'termsVersion'
 *   },
 * });
 */
export function useRegisterClientMutation(baseOptions?: Apollo.MutationHookOptions<RegisterClientMutation, RegisterClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterClientMutation, RegisterClientMutationVariables>(RegisterClientDocument, options);
      }
export type RegisterClientMutationHookResult = ReturnType<typeof useRegisterClientMutation>;
export type RegisterClientMutationResult = Apollo.MutationResult<RegisterClientMutation>;
export type RegisterClientMutationOptions = Apollo.BaseMutationOptions<RegisterClientMutation, RegisterClientMutationVariables>;
export const RegisterHelperDocument = gql`
    mutation RegisterHelper($firstName: String!, $lastName: String!, $email: String!, $password: String!) {
  registerHelper(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
  ) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type RegisterHelperMutationFn = Apollo.MutationFunction<RegisterHelperMutation, RegisterHelperMutationVariables>;

/**
 * __useRegisterHelperMutation__
 *
 * To run a mutation, you first call `useRegisterHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerHelperMutation, { data, loading, error }] = useRegisterHelperMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegisterHelperMutation(baseOptions?: Apollo.MutationHookOptions<RegisterHelperMutation, RegisterHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterHelperMutation, RegisterHelperMutationVariables>(RegisterHelperDocument, options);
      }
export type RegisterHelperMutationHookResult = ReturnType<typeof useRegisterHelperMutation>;
export type RegisterHelperMutationResult = Apollo.MutationResult<RegisterHelperMutation>;
export type RegisterHelperMutationOptions = Apollo.BaseMutationOptions<RegisterHelperMutation, RegisterHelperMutationVariables>;
export const ResendActivationLinkDocument = gql`
    mutation ResendActivationLink {
  reSendActivationLink
}
    `;
export type ResendActivationLinkMutationFn = Apollo.MutationFunction<ResendActivationLinkMutation, ResendActivationLinkMutationVariables>;

/**
 * __useResendActivationLinkMutation__
 *
 * To run a mutation, you first call `useResendActivationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationLinkMutation, { data, loading, error }] = useResendActivationLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendActivationLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationLinkMutation, ResendActivationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationLinkMutation, ResendActivationLinkMutationVariables>(ResendActivationLinkDocument, options);
      }
export type ResendActivationLinkMutationHookResult = ReturnType<typeof useResendActivationLinkMutation>;
export type ResendActivationLinkMutationResult = Apollo.MutationResult<ResendActivationLinkMutation>;
export type ResendActivationLinkMutationOptions = Apollo.BaseMutationOptions<ResendActivationLinkMutation, ResendActivationLinkMutationVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($clientId: Int!) {
  deleteClient(clientId: $clientId) {
    id
  }
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($firstName: String!, $lastName: String!, $email: String!, $companyName: String!, $sendInvite: Boolean!) {
  createClient(
    firstName: $firstName
    lastName: $lastName
    email: $email
    companyName: $companyName
    sendInvite: $sendInvite
  ) {
    id
  }
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      companyName: // value for 'companyName'
 *      sendInvite: // value for 'sendInvite'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientsDocument = gql`
    mutation UpdateClients($clientId: Int!, $firstName: String!, $lastName: String!, $email: String!, $companyName: String!) {
  updateClient(
    clientId: $clientId
    firstName: $firstName
    lastName: $lastName
    email: $email
    companyName: $companyName
  ) {
    id
  }
}
    `;
export type UpdateClientsMutationFn = Apollo.MutationFunction<UpdateClientsMutation, UpdateClientsMutationVariables>;

/**
 * __useUpdateClientsMutation__
 *
 * To run a mutation, you first call `useUpdateClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientsMutation, { data, loading, error }] = useUpdateClientsMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useUpdateClientsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientsMutation, UpdateClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientsMutation, UpdateClientsMutationVariables>(UpdateClientsDocument, options);
      }
export type UpdateClientsMutationHookResult = ReturnType<typeof useUpdateClientsMutation>;
export type UpdateClientsMutationResult = Apollo.MutationResult<UpdateClientsMutation>;
export type UpdateClientsMutationOptions = Apollo.BaseMutationOptions<UpdateClientsMutation, UpdateClientsMutationVariables>;
export const UpdateClientInfoDocument = gql`
    mutation UpdateClientInfo($clientId: Int!, $firstName: String!, $lastName: String!) {
  updateClientInfo(
    clientId: $clientId
    firstName: $firstName
    lastName: $lastName
  ) {
    id
    firstName
    lastName
  }
}
    `;
export type UpdateClientInfoMutationFn = Apollo.MutationFunction<UpdateClientInfoMutation, UpdateClientInfoMutationVariables>;

/**
 * __useUpdateClientInfoMutation__
 *
 * To run a mutation, you first call `useUpdateClientInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientInfoMutation, { data, loading, error }] = useUpdateClientInfoMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateClientInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientInfoMutation, UpdateClientInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientInfoMutation, UpdateClientInfoMutationVariables>(UpdateClientInfoDocument, options);
      }
export type UpdateClientInfoMutationHookResult = ReturnType<typeof useUpdateClientInfoMutation>;
export type UpdateClientInfoMutationResult = Apollo.MutationResult<UpdateClientInfoMutation>;
export type UpdateClientInfoMutationOptions = Apollo.BaseMutationOptions<UpdateClientInfoMutation, UpdateClientInfoMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($email: String, $oldPassword: String!, $newPassword: String!) {
  ChangePassword(
    email: $email
    oldPassword: $oldPassword
    newPassword: $newPassword
  ) {
    id
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ToggleClientAccountDocument = gql`
    mutation ToggleClientAccount($clientId: Int!) {
  ToggleAccount(accountId: $clientId, accountType: CLIENT)
}
    `;
export type ToggleClientAccountMutationFn = Apollo.MutationFunction<ToggleClientAccountMutation, ToggleClientAccountMutationVariables>;

/**
 * __useToggleClientAccountMutation__
 *
 * To run a mutation, you first call `useToggleClientAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleClientAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleClientAccountMutation, { data, loading, error }] = useToggleClientAccountMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useToggleClientAccountMutation(baseOptions?: Apollo.MutationHookOptions<ToggleClientAccountMutation, ToggleClientAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleClientAccountMutation, ToggleClientAccountMutationVariables>(ToggleClientAccountDocument, options);
      }
export type ToggleClientAccountMutationHookResult = ReturnType<typeof useToggleClientAccountMutation>;
export type ToggleClientAccountMutationResult = Apollo.MutationResult<ToggleClientAccountMutation>;
export type ToggleClientAccountMutationOptions = Apollo.BaseMutationOptions<ToggleClientAccountMutation, ToggleClientAccountMutationVariables>;
export const SendClientActivationLinkDocument = gql`
    mutation SendClientActivationLink($clientId: Int!) {
  sendClientActivationLink(clientId: $clientId)
}
    `;
export type SendClientActivationLinkMutationFn = Apollo.MutationFunction<SendClientActivationLinkMutation, SendClientActivationLinkMutationVariables>;

/**
 * __useSendClientActivationLinkMutation__
 *
 * To run a mutation, you first call `useSendClientActivationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendClientActivationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendClientActivationLinkMutation, { data, loading, error }] = useSendClientActivationLinkMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSendClientActivationLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendClientActivationLinkMutation, SendClientActivationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendClientActivationLinkMutation, SendClientActivationLinkMutationVariables>(SendClientActivationLinkDocument, options);
      }
export type SendClientActivationLinkMutationHookResult = ReturnType<typeof useSendClientActivationLinkMutation>;
export type SendClientActivationLinkMutationResult = Apollo.MutationResult<SendClientActivationLinkMutation>;
export type SendClientActivationLinkMutationOptions = Apollo.BaseMutationOptions<SendClientActivationLinkMutation, SendClientActivationLinkMutationVariables>;
export const UpgradePricingPlanDocument = gql`
    mutation UpgradePricingPlan($clientId: Int!) {
  upgradeClientPlan(clientId: $clientId)
}
    `;
export type UpgradePricingPlanMutationFn = Apollo.MutationFunction<UpgradePricingPlanMutation, UpgradePricingPlanMutationVariables>;

/**
 * __useUpgradePricingPlanMutation__
 *
 * To run a mutation, you first call `useUpgradePricingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePricingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePricingPlanMutation, { data, loading, error }] = useUpgradePricingPlanMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useUpgradePricingPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpgradePricingPlanMutation, UpgradePricingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradePricingPlanMutation, UpgradePricingPlanMutationVariables>(UpgradePricingPlanDocument, options);
      }
export type UpgradePricingPlanMutationHookResult = ReturnType<typeof useUpgradePricingPlanMutation>;
export type UpgradePricingPlanMutationResult = Apollo.MutationResult<UpgradePricingPlanMutation>;
export type UpgradePricingPlanMutationOptions = Apollo.BaseMutationOptions<UpgradePricingPlanMutation, UpgradePricingPlanMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  CreateProject(input: $input) {
    id
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateVideoProjectDocument = gql`
    mutation CreateVideoProject($input: CreateVideoAnnotationProjectInput!) {
  CreateVideoAnnotationProject(input: $input) {
    id
  }
}
    `;
export type CreateVideoProjectMutationFn = Apollo.MutationFunction<CreateVideoProjectMutation, CreateVideoProjectMutationVariables>;

/**
 * __useCreateVideoProjectMutation__
 *
 * To run a mutation, you first call `useCreateVideoProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoProjectMutation, { data, loading, error }] = useCreateVideoProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoProjectMutation, CreateVideoProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoProjectMutation, CreateVideoProjectMutationVariables>(CreateVideoProjectDocument, options);
      }
export type CreateVideoProjectMutationHookResult = ReturnType<typeof useCreateVideoProjectMutation>;
export type CreateVideoProjectMutationResult = Apollo.MutationResult<CreateVideoProjectMutation>;
export type CreateVideoProjectMutationOptions = Apollo.BaseMutationOptions<CreateVideoProjectMutation, CreateVideoProjectMutationVariables>;
export const CreateMultiImageProjectDocument = gql`
    mutation CreateMultiImageProject($input: CreateProjectInput) {
  createMultiImageProject(input: $input) {
    id
  }
}
    `;
export type CreateMultiImageProjectMutationFn = Apollo.MutationFunction<CreateMultiImageProjectMutation, CreateMultiImageProjectMutationVariables>;

/**
 * __useCreateMultiImageProjectMutation__
 *
 * To run a mutation, you first call `useCreateMultiImageProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiImageProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiImageProjectMutation, { data, loading, error }] = useCreateMultiImageProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMultiImageProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiImageProjectMutation, CreateMultiImageProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiImageProjectMutation, CreateMultiImageProjectMutationVariables>(CreateMultiImageProjectDocument, options);
      }
export type CreateMultiImageProjectMutationHookResult = ReturnType<typeof useCreateMultiImageProjectMutation>;
export type CreateMultiImageProjectMutationResult = Apollo.MutationResult<CreateMultiImageProjectMutation>;
export type CreateMultiImageProjectMutationOptions = Apollo.BaseMutationOptions<CreateMultiImageProjectMutation, CreateMultiImageProjectMutationVariables>;
export const UploadInstructionFileDocument = gql`
    mutation UploadInstructionFile($file: Upload!) {
  projectAdminInstructionUpload(file: $file) {
    fname
  }
}
    `;
export type UploadInstructionFileMutationFn = Apollo.MutationFunction<UploadInstructionFileMutation, UploadInstructionFileMutationVariables>;

/**
 * __useUploadInstructionFileMutation__
 *
 * To run a mutation, you first call `useUploadInstructionFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInstructionFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInstructionFileMutation, { data, loading, error }] = useUploadInstructionFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadInstructionFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadInstructionFileMutation, UploadInstructionFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInstructionFileMutation, UploadInstructionFileMutationVariables>(UploadInstructionFileDocument, options);
      }
export type UploadInstructionFileMutationHookResult = ReturnType<typeof useUploadInstructionFileMutation>;
export type UploadInstructionFileMutationResult = Apollo.MutationResult<UploadInstructionFileMutation>;
export type UploadInstructionFileMutationOptions = Apollo.BaseMutationOptions<UploadInstructionFileMutation, UploadInstructionFileMutationVariables>;
export const UploadClientInstructionFilesDocument = gql`
    mutation UploadClientInstructionFiles($file: Upload!) {
  projectClientInstructionUpload(file: $file) {
    fname
  }
}
    `;
export type UploadClientInstructionFilesMutationFn = Apollo.MutationFunction<UploadClientInstructionFilesMutation, UploadClientInstructionFilesMutationVariables>;

/**
 * __useUploadClientInstructionFilesMutation__
 *
 * To run a mutation, you first call `useUploadClientInstructionFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadClientInstructionFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadClientInstructionFilesMutation, { data, loading, error }] = useUploadClientInstructionFilesMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadClientInstructionFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadClientInstructionFilesMutation, UploadClientInstructionFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadClientInstructionFilesMutation, UploadClientInstructionFilesMutationVariables>(UploadClientInstructionFilesDocument, options);
      }
export type UploadClientInstructionFilesMutationHookResult = ReturnType<typeof useUploadClientInstructionFilesMutation>;
export type UploadClientInstructionFilesMutationResult = Apollo.MutationResult<UploadClientInstructionFilesMutation>;
export type UploadClientInstructionFilesMutationOptions = Apollo.BaseMutationOptions<UploadClientInstructionFilesMutation, UploadClientInstructionFilesMutationVariables>;
export const CreateGoogleDriveProjectDocument = gql`
    mutation CreateGoogleDriveProject($input: CreateProjectInput) {
  createGoogleDriveProject(input: $input) {
    id
  }
}
    `;
export type CreateGoogleDriveProjectMutationFn = Apollo.MutationFunction<CreateGoogleDriveProjectMutation, CreateGoogleDriveProjectMutationVariables>;

/**
 * __useCreateGoogleDriveProjectMutation__
 *
 * To run a mutation, you first call `useCreateGoogleDriveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoogleDriveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoogleDriveProjectMutation, { data, loading, error }] = useCreateGoogleDriveProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGoogleDriveProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoogleDriveProjectMutation, CreateGoogleDriveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoogleDriveProjectMutation, CreateGoogleDriveProjectMutationVariables>(CreateGoogleDriveProjectDocument, options);
      }
export type CreateGoogleDriveProjectMutationHookResult = ReturnType<typeof useCreateGoogleDriveProjectMutation>;
export type CreateGoogleDriveProjectMutationResult = Apollo.MutationResult<CreateGoogleDriveProjectMutation>;
export type CreateGoogleDriveProjectMutationOptions = Apollo.BaseMutationOptions<CreateGoogleDriveProjectMutation, CreateGoogleDriveProjectMutationVariables>;
export const SaveDraftProjectDocument = gql`
    mutation SaveDraftProject($input: DraftCreateProjectInput) {
  saveDraftProject(input: $input) {
    id
  }
}
    `;
export type SaveDraftProjectMutationFn = Apollo.MutationFunction<SaveDraftProjectMutation, SaveDraftProjectMutationVariables>;

/**
 * __useSaveDraftProjectMutation__
 *
 * To run a mutation, you first call `useSaveDraftProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftProjectMutation, { data, loading, error }] = useSaveDraftProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDraftProjectMutation(baseOptions?: Apollo.MutationHookOptions<SaveDraftProjectMutation, SaveDraftProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDraftProjectMutation, SaveDraftProjectMutationVariables>(SaveDraftProjectDocument, options);
      }
export type SaveDraftProjectMutationHookResult = ReturnType<typeof useSaveDraftProjectMutation>;
export type SaveDraftProjectMutationResult = Apollo.MutationResult<SaveDraftProjectMutation>;
export type SaveDraftProjectMutationOptions = Apollo.BaseMutationOptions<SaveDraftProjectMutation, SaveDraftProjectMutationVariables>;
export const SendRequestToHelperDocument = gql`
    mutation SendRequestToHelper($email: String!, $projectId: Int!, $firstName: String!, $lastName: String!) {
  sendRequestToHelper(
    email: $email
    projectId: $projectId
    firstName: $firstName
    lastName: $lastName
  )
}
    `;
export type SendRequestToHelperMutationFn = Apollo.MutationFunction<SendRequestToHelperMutation, SendRequestToHelperMutationVariables>;

/**
 * __useSendRequestToHelperMutation__
 *
 * To run a mutation, you first call `useSendRequestToHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRequestToHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRequestToHelperMutation, { data, loading, error }] = useSendRequestToHelperMutation({
 *   variables: {
 *      email: // value for 'email'
 *      projectId: // value for 'projectId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useSendRequestToHelperMutation(baseOptions?: Apollo.MutationHookOptions<SendRequestToHelperMutation, SendRequestToHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRequestToHelperMutation, SendRequestToHelperMutationVariables>(SendRequestToHelperDocument, options);
      }
export type SendRequestToHelperMutationHookResult = ReturnType<typeof useSendRequestToHelperMutation>;
export type SendRequestToHelperMutationResult = Apollo.MutationResult<SendRequestToHelperMutation>;
export type SendRequestToHelperMutationOptions = Apollo.BaseMutationOptions<SendRequestToHelperMutation, SendRequestToHelperMutationVariables>;
export const RequestHelpersDocument = gql`
    mutation RequestHelpers($comment: String!, $projectId: Int!) {
  requestHelpers(comment: $comment, projectId: $projectId)
}
    `;
export type RequestHelpersMutationFn = Apollo.MutationFunction<RequestHelpersMutation, RequestHelpersMutationVariables>;

/**
 * __useRequestHelpersMutation__
 *
 * To run a mutation, you first call `useRequestHelpersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestHelpersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestHelpersMutation, { data, loading, error }] = useRequestHelpersMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRequestHelpersMutation(baseOptions?: Apollo.MutationHookOptions<RequestHelpersMutation, RequestHelpersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestHelpersMutation, RequestHelpersMutationVariables>(RequestHelpersDocument, options);
      }
export type RequestHelpersMutationHookResult = ReturnType<typeof useRequestHelpersMutation>;
export type RequestHelpersMutationResult = Apollo.MutationResult<RequestHelpersMutation>;
export type RequestHelpersMutationOptions = Apollo.BaseMutationOptions<RequestHelpersMutation, RequestHelpersMutationVariables>;
export const ProjectMediaUploadDocument = gql`
    mutation ProjectMediaUpload($file: Upload!, $clientId: Int) {
  projectMediaUpload(file: $file, clientId: $clientId)
}
    `;
export type ProjectMediaUploadMutationFn = Apollo.MutationFunction<ProjectMediaUploadMutation, ProjectMediaUploadMutationVariables>;

/**
 * __useProjectMediaUploadMutation__
 *
 * To run a mutation, you first call `useProjectMediaUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMediaUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMediaUploadMutation, { data, loading, error }] = useProjectMediaUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useProjectMediaUploadMutation(baseOptions?: Apollo.MutationHookOptions<ProjectMediaUploadMutation, ProjectMediaUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectMediaUploadMutation, ProjectMediaUploadMutationVariables>(ProjectMediaUploadDocument, options);
      }
export type ProjectMediaUploadMutationHookResult = ReturnType<typeof useProjectMediaUploadMutation>;
export type ProjectMediaUploadMutationResult = Apollo.MutationResult<ProjectMediaUploadMutation>;
export type ProjectMediaUploadMutationOptions = Apollo.BaseMutationOptions<ProjectMediaUploadMutation, ProjectMediaUploadMutationVariables>;
export const DeleteHelperDocument = gql`
    mutation DeleteHelper($helperId: Int!) {
  deleteHelper(helperId: $helperId) {
    id
  }
}
    `;
export type DeleteHelperMutationFn = Apollo.MutationFunction<DeleteHelperMutation, DeleteHelperMutationVariables>;

/**
 * __useDeleteHelperMutation__
 *
 * To run a mutation, you first call `useDeleteHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHelperMutation, { data, loading, error }] = useDeleteHelperMutation({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useDeleteHelperMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHelperMutation, DeleteHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHelperMutation, DeleteHelperMutationVariables>(DeleteHelperDocument, options);
      }
export type DeleteHelperMutationHookResult = ReturnType<typeof useDeleteHelperMutation>;
export type DeleteHelperMutationResult = Apollo.MutationResult<DeleteHelperMutation>;
export type DeleteHelperMutationOptions = Apollo.BaseMutationOptions<DeleteHelperMutation, DeleteHelperMutationVariables>;
export const CreateHelperDocument = gql`
    mutation CreateHelper($firstName: String!, $lastName: String!, $email: String!) {
  createHelper(firstName: $firstName, lastName: $lastName, email: $email) {
    id
  }
}
    `;
export type CreateHelperMutationFn = Apollo.MutationFunction<CreateHelperMutation, CreateHelperMutationVariables>;

/**
 * __useCreateHelperMutation__
 *
 * To run a mutation, you first call `useCreateHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHelperMutation, { data, loading, error }] = useCreateHelperMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateHelperMutation(baseOptions?: Apollo.MutationHookOptions<CreateHelperMutation, CreateHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHelperMutation, CreateHelperMutationVariables>(CreateHelperDocument, options);
      }
export type CreateHelperMutationHookResult = ReturnType<typeof useCreateHelperMutation>;
export type CreateHelperMutationResult = Apollo.MutationResult<CreateHelperMutation>;
export type CreateHelperMutationOptions = Apollo.BaseMutationOptions<CreateHelperMutation, CreateHelperMutationVariables>;
export const UpdateHelperDocument = gql`
    mutation UpdateHelper($helperId: Int!, $firstName: String!, $lastName: String!, $email: String!) {
  updateHelper(
    helperId: $helperId
    firstName: $firstName
    lastName: $lastName
    email: $email
  ) {
    id
  }
}
    `;
export type UpdateHelperMutationFn = Apollo.MutationFunction<UpdateHelperMutation, UpdateHelperMutationVariables>;

/**
 * __useUpdateHelperMutation__
 *
 * To run a mutation, you first call `useUpdateHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHelperMutation, { data, loading, error }] = useUpdateHelperMutation({
 *   variables: {
 *      helperId: // value for 'helperId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateHelperMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHelperMutation, UpdateHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHelperMutation, UpdateHelperMutationVariables>(UpdateHelperDocument, options);
      }
export type UpdateHelperMutationHookResult = ReturnType<typeof useUpdateHelperMutation>;
export type UpdateHelperMutationResult = Apollo.MutationResult<UpdateHelperMutation>;
export type UpdateHelperMutationOptions = Apollo.BaseMutationOptions<UpdateHelperMutation, UpdateHelperMutationVariables>;
export const ToggleHelperAccountDocument = gql`
    mutation ToggleHelperAccount($helperId: Int!) {
  ToggleAccount(accountId: $helperId, accountType: HELPER)
}
    `;
export type ToggleHelperAccountMutationFn = Apollo.MutationFunction<ToggleHelperAccountMutation, ToggleHelperAccountMutationVariables>;

/**
 * __useToggleHelperAccountMutation__
 *
 * To run a mutation, you first call `useToggleHelperAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleHelperAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleHelperAccountMutation, { data, loading, error }] = useToggleHelperAccountMutation({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useToggleHelperAccountMutation(baseOptions?: Apollo.MutationHookOptions<ToggleHelperAccountMutation, ToggleHelperAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleHelperAccountMutation, ToggleHelperAccountMutationVariables>(ToggleHelperAccountDocument, options);
      }
export type ToggleHelperAccountMutationHookResult = ReturnType<typeof useToggleHelperAccountMutation>;
export type ToggleHelperAccountMutationResult = Apollo.MutationResult<ToggleHelperAccountMutation>;
export type ToggleHelperAccountMutationOptions = Apollo.BaseMutationOptions<ToggleHelperAccountMutation, ToggleHelperAccountMutationVariables>;
export const AcceptInviteByHelperDocument = gql`
    mutation AcceptInviteByHelper($id: Int!) {
  acceptInviteByHelper(inviteId: $id)
}
    `;
export type AcceptInviteByHelperMutationFn = Apollo.MutationFunction<AcceptInviteByHelperMutation, AcceptInviteByHelperMutationVariables>;

/**
 * __useAcceptInviteByHelperMutation__
 *
 * To run a mutation, you first call `useAcceptInviteByHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteByHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteByHelperMutation, { data, loading, error }] = useAcceptInviteByHelperMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptInviteByHelperMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteByHelperMutation, AcceptInviteByHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteByHelperMutation, AcceptInviteByHelperMutationVariables>(AcceptInviteByHelperDocument, options);
      }
export type AcceptInviteByHelperMutationHookResult = ReturnType<typeof useAcceptInviteByHelperMutation>;
export type AcceptInviteByHelperMutationResult = Apollo.MutationResult<AcceptInviteByHelperMutation>;
export type AcceptInviteByHelperMutationOptions = Apollo.BaseMutationOptions<AcceptInviteByHelperMutation, AcceptInviteByHelperMutationVariables>;
export const SaveLearningProgressDocument = gql`
    mutation SaveLearningProgress($topic: Int!, $lesson: Int!) {
  saveLearningProgress(topic: $topic, lesson: $lesson) {
    id
  }
}
    `;
export type SaveLearningProgressMutationFn = Apollo.MutationFunction<SaveLearningProgressMutation, SaveLearningProgressMutationVariables>;

/**
 * __useSaveLearningProgressMutation__
 *
 * To run a mutation, you first call `useSaveLearningProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLearningProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLearningProgressMutation, { data, loading, error }] = useSaveLearningProgressMutation({
 *   variables: {
 *      topic: // value for 'topic'
 *      lesson: // value for 'lesson'
 *   },
 * });
 */
export function useSaveLearningProgressMutation(baseOptions?: Apollo.MutationHookOptions<SaveLearningProgressMutation, SaveLearningProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLearningProgressMutation, SaveLearningProgressMutationVariables>(SaveLearningProgressDocument, options);
      }
export type SaveLearningProgressMutationHookResult = ReturnType<typeof useSaveLearningProgressMutation>;
export type SaveLearningProgressMutationResult = Apollo.MutationResult<SaveLearningProgressMutation>;
export type SaveLearningProgressMutationOptions = Apollo.BaseMutationOptions<SaveLearningProgressMutation, SaveLearningProgressMutationVariables>;
export const SubmitLessonPracticeDocument = gql`
    mutation SubmitLessonPractice($topicId: Int!, $lessonId: Int!, $practiceId: Int!, $result: JSONObject!) {
  submitLessonPractice(
    topicId: $topicId
    lessonId: $lessonId
    practiceId: $practiceId
    result: $result
  ) {
    result
    next {
      type
      settings {
        chunkLength
        subType
        annotationType
      }
      mediaFileName
      labels
      mediaUrl
      videoChunkLength
      videoStart
      videoEnd
      videoFPS
      videoFrameCount
    }
    totalSessionSize
    currentTaskIndex
  }
}
    `;
export type SubmitLessonPracticeMutationFn = Apollo.MutationFunction<SubmitLessonPracticeMutation, SubmitLessonPracticeMutationVariables>;

/**
 * __useSubmitLessonPracticeMutation__
 *
 * To run a mutation, you first call `useSubmitLessonPracticeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLessonPracticeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLessonPracticeMutation, { data, loading, error }] = useSubmitLessonPracticeMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      lessonId: // value for 'lessonId'
 *      practiceId: // value for 'practiceId'
 *      result: // value for 'result'
 *   },
 * });
 */
export function useSubmitLessonPracticeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLessonPracticeMutation, SubmitLessonPracticeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLessonPracticeMutation, SubmitLessonPracticeMutationVariables>(SubmitLessonPracticeDocument, options);
      }
export type SubmitLessonPracticeMutationHookResult = ReturnType<typeof useSubmitLessonPracticeMutation>;
export type SubmitLessonPracticeMutationResult = Apollo.MutationResult<SubmitLessonPracticeMutation>;
export type SubmitLessonPracticeMutationOptions = Apollo.BaseMutationOptions<SubmitLessonPracticeMutation, SubmitLessonPracticeMutationVariables>;
export const ArchiveProjectDocument = gql`
    mutation ArchiveProject($projectId: Int!) {
  archiveProject(projectId: $projectId)
}
    `;
export type ArchiveProjectMutationFn = Apollo.MutationFunction<ArchiveProjectMutation, ArchiveProjectMutationVariables>;

/**
 * __useArchiveProjectMutation__
 *
 * To run a mutation, you first call `useArchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProjectMutation, { data, loading, error }] = useArchiveProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useArchiveProjectMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument, options);
      }
export type ArchiveProjectMutationHookResult = ReturnType<typeof useArchiveProjectMutation>;
export type ArchiveProjectMutationResult = Apollo.MutationResult<ArchiveProjectMutation>;
export type ArchiveProjectMutationOptions = Apollo.BaseMutationOptions<ArchiveProjectMutation, ArchiveProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($input: ProjectUpdateInput) {
  updateProject(input: $input) {
    id
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const ProjectUpdateStatusDocument = gql`
    mutation ProjectUpdateStatus($input: ProjectUpdateStatusInput) {
  updateStatus(input: $input) {
    id
  }
}
    `;
export type ProjectUpdateStatusMutationFn = Apollo.MutationFunction<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>;

/**
 * __useProjectUpdateStatusMutation__
 *
 * To run a mutation, you first call `useProjectUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateStatusMutation, { data, loading, error }] = useProjectUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>(ProjectUpdateStatusDocument, options);
      }
export type ProjectUpdateStatusMutationHookResult = ReturnType<typeof useProjectUpdateStatusMutation>;
export type ProjectUpdateStatusMutationResult = Apollo.MutationResult<ProjectUpdateStatusMutation>;
export type ProjectUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>;
export const ProjectUpdateInfoDocument = gql`
    mutation ProjectUpdateInfo($input: ProjectUpdateInfoInput) {
  updateInfo(input: $input) {
    id
  }
}
    `;
export type ProjectUpdateInfoMutationFn = Apollo.MutationFunction<ProjectUpdateInfoMutation, ProjectUpdateInfoMutationVariables>;

/**
 * __useProjectUpdateInfoMutation__
 *
 * To run a mutation, you first call `useProjectUpdateInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateInfoMutation, { data, loading, error }] = useProjectUpdateInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUpdateInfoMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateInfoMutation, ProjectUpdateInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateInfoMutation, ProjectUpdateInfoMutationVariables>(ProjectUpdateInfoDocument, options);
      }
export type ProjectUpdateInfoMutationHookResult = ReturnType<typeof useProjectUpdateInfoMutation>;
export type ProjectUpdateInfoMutationResult = Apollo.MutationResult<ProjectUpdateInfoMutation>;
export type ProjectUpdateInfoMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateInfoMutation, ProjectUpdateInfoMutationVariables>;
export const ProjectUpdateRateDocument = gql`
    mutation ProjectUpdateRate($input: ProjectUpdateRateInput) {
  updateRate(input: $input) {
    id
  }
}
    `;
export type ProjectUpdateRateMutationFn = Apollo.MutationFunction<ProjectUpdateRateMutation, ProjectUpdateRateMutationVariables>;

/**
 * __useProjectUpdateRateMutation__
 *
 * To run a mutation, you first call `useProjectUpdateRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateRateMutation, { data, loading, error }] = useProjectUpdateRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUpdateRateMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateRateMutation, ProjectUpdateRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateRateMutation, ProjectUpdateRateMutationVariables>(ProjectUpdateRateDocument, options);
      }
export type ProjectUpdateRateMutationHookResult = ReturnType<typeof useProjectUpdateRateMutation>;
export type ProjectUpdateRateMutationResult = Apollo.MutationResult<ProjectUpdateRateMutation>;
export type ProjectUpdateRateMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateRateMutation, ProjectUpdateRateMutationVariables>;
export const ProjectUpdateFilesDocument = gql`
    mutation ProjectUpdateFiles($input: ProjectUpdateFilesInput) {
  updateFiles(input: $input) {
    id
  }
}
    `;
export type ProjectUpdateFilesMutationFn = Apollo.MutationFunction<ProjectUpdateFilesMutation, ProjectUpdateFilesMutationVariables>;

/**
 * __useProjectUpdateFilesMutation__
 *
 * To run a mutation, you first call `useProjectUpdateFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateFilesMutation, { data, loading, error }] = useProjectUpdateFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUpdateFilesMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateFilesMutation, ProjectUpdateFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateFilesMutation, ProjectUpdateFilesMutationVariables>(ProjectUpdateFilesDocument, options);
      }
export type ProjectUpdateFilesMutationHookResult = ReturnType<typeof useProjectUpdateFilesMutation>;
export type ProjectUpdateFilesMutationResult = Apollo.MutationResult<ProjectUpdateFilesMutation>;
export type ProjectUpdateFilesMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateFilesMutation, ProjectUpdateFilesMutationVariables>;
export const ProjectUpdateAssignedHelperDocument = gql`
    mutation ProjectUpdateAssignedHelper($input: ProjectUpdateHelpersInput) {
  updateAssignedHelper(input: $input) {
    id
  }
}
    `;
export type ProjectUpdateAssignedHelperMutationFn = Apollo.MutationFunction<ProjectUpdateAssignedHelperMutation, ProjectUpdateAssignedHelperMutationVariables>;

/**
 * __useProjectUpdateAssignedHelperMutation__
 *
 * To run a mutation, you first call `useProjectUpdateAssignedHelperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateAssignedHelperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateAssignedHelperMutation, { data, loading, error }] = useProjectUpdateAssignedHelperMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUpdateAssignedHelperMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateAssignedHelperMutation, ProjectUpdateAssignedHelperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateAssignedHelperMutation, ProjectUpdateAssignedHelperMutationVariables>(ProjectUpdateAssignedHelperDocument, options);
      }
export type ProjectUpdateAssignedHelperMutationHookResult = ReturnType<typeof useProjectUpdateAssignedHelperMutation>;
export type ProjectUpdateAssignedHelperMutationResult = Apollo.MutationResult<ProjectUpdateAssignedHelperMutation>;
export type ProjectUpdateAssignedHelperMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateAssignedHelperMutation, ProjectUpdateAssignedHelperMutationVariables>;
export const ProjectUpdateAssignedAuditorDocument = gql`
    mutation ProjectUpdateAssignedAuditor($input: ProjectUpdateAuditorsInput) {
  updateAssignedAuditor(input: $input) {
    id
  }
}
    `;
export type ProjectUpdateAssignedAuditorMutationFn = Apollo.MutationFunction<ProjectUpdateAssignedAuditorMutation, ProjectUpdateAssignedAuditorMutationVariables>;

/**
 * __useProjectUpdateAssignedAuditorMutation__
 *
 * To run a mutation, you first call `useProjectUpdateAssignedAuditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateAssignedAuditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateAssignedAuditorMutation, { data, loading, error }] = useProjectUpdateAssignedAuditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectUpdateAssignedAuditorMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateAssignedAuditorMutation, ProjectUpdateAssignedAuditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateAssignedAuditorMutation, ProjectUpdateAssignedAuditorMutationVariables>(ProjectUpdateAssignedAuditorDocument, options);
      }
export type ProjectUpdateAssignedAuditorMutationHookResult = ReturnType<typeof useProjectUpdateAssignedAuditorMutation>;
export type ProjectUpdateAssignedAuditorMutationResult = Apollo.MutationResult<ProjectUpdateAssignedAuditorMutation>;
export type ProjectUpdateAssignedAuditorMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateAssignedAuditorMutation, ProjectUpdateAssignedAuditorMutationVariables>;
export const UploadOverrideZipDocument = gql`
    mutation UploadOverrideZip($fileName: String!, $projectId: Int!) {
  projectOverwriteTasks(projectId: $projectId, mediaFileName: $fileName)
}
    `;
export type UploadOverrideZipMutationFn = Apollo.MutationFunction<UploadOverrideZipMutation, UploadOverrideZipMutationVariables>;

/**
 * __useUploadOverrideZipMutation__
 *
 * To run a mutation, you first call `useUploadOverrideZipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOverrideZipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOverrideZipMutation, { data, loading, error }] = useUploadOverrideZipMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUploadOverrideZipMutation(baseOptions?: Apollo.MutationHookOptions<UploadOverrideZipMutation, UploadOverrideZipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadOverrideZipMutation, UploadOverrideZipMutationVariables>(UploadOverrideZipDocument, options);
      }
export type UploadOverrideZipMutationHookResult = ReturnType<typeof useUploadOverrideZipMutation>;
export type UploadOverrideZipMutationResult = Apollo.MutationResult<UploadOverrideZipMutation>;
export type UploadOverrideZipMutationOptions = Apollo.BaseMutationOptions<UploadOverrideZipMutation, UploadOverrideZipMutationVariables>;
export const CopyProjectDocument = gql`
    mutation CopyProject($projectId: Int!, $newTitle: String!) {
  copyProject(projectId: $projectId, newTitle: $newTitle) {
    id
  }
}
    `;
export type CopyProjectMutationFn = Apollo.MutationFunction<CopyProjectMutation, CopyProjectMutationVariables>;

/**
 * __useCopyProjectMutation__
 *
 * To run a mutation, you first call `useCopyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyProjectMutation, { data, loading, error }] = useCopyProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      newTitle: // value for 'newTitle'
 *   },
 * });
 */
export function useCopyProjectMutation(baseOptions?: Apollo.MutationHookOptions<CopyProjectMutation, CopyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyProjectMutation, CopyProjectMutationVariables>(CopyProjectDocument, options);
      }
export type CopyProjectMutationHookResult = ReturnType<typeof useCopyProjectMutation>;
export type CopyProjectMutationResult = Apollo.MutationResult<CopyProjectMutation>;
export type CopyProjectMutationOptions = Apollo.BaseMutationOptions<CopyProjectMutation, CopyProjectMutationVariables>;
export const UpdateTaskByIdDocument = gql`
    mutation UpdateTaskById($toStatus: TaskStatus, $fromStatus: TaskStatus, $toHelperId: Int, $fromHelperId: Int, $toAuditorId: Int, $fromAuditorId: Int, $taskId: Int!) {
  updateTask(
    toStatus: $toStatus
    toHelperId: $toHelperId
    toAuditorId: $toAuditorId
    taskId: $taskId
    fromStatus: $fromStatus
    fromHelperId: $fromHelperId
    fromAuditorId: $fromAuditorId
  ) {
    id
  }
}
    `;
export type UpdateTaskByIdMutationFn = Apollo.MutationFunction<UpdateTaskByIdMutation, UpdateTaskByIdMutationVariables>;

/**
 * __useUpdateTaskByIdMutation__
 *
 * To run a mutation, you first call `useUpdateTaskByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskByIdMutation, { data, loading, error }] = useUpdateTaskByIdMutation({
 *   variables: {
 *      toStatus: // value for 'toStatus'
 *      fromStatus: // value for 'fromStatus'
 *      toHelperId: // value for 'toHelperId'
 *      fromHelperId: // value for 'fromHelperId'
 *      toAuditorId: // value for 'toAuditorId'
 *      fromAuditorId: // value for 'fromAuditorId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useUpdateTaskByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskByIdMutation, UpdateTaskByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskByIdMutation, UpdateTaskByIdMutationVariables>(UpdateTaskByIdDocument, options);
      }
export type UpdateTaskByIdMutationHookResult = ReturnType<typeof useUpdateTaskByIdMutation>;
export type UpdateTaskByIdMutationResult = Apollo.MutationResult<UpdateTaskByIdMutation>;
export type UpdateTaskByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTaskByIdMutation, UpdateTaskByIdMutationVariables>;
export const UpdateTasksByProjectIdDocument = gql`
    mutation UpdateTasksByProjectId($toStatus: TaskStatus, $fromStatus: TaskStatus, $toHelperId: Int, $fromHelperId: Int, $toAuditorId: Int, $fromAuditorId: Int, $projectId: Int!) {
  bulkUpdateTasks(
    projectId: $projectId
    toStatus: $toStatus
    toHelperId: $toHelperId
    toAuditorId: $toAuditorId
    fromStatus: $fromStatus
    fromHelperId: $fromHelperId
    fromAuditorId: $fromAuditorId
  ) {
    updatedTasksCount
  }
}
    `;
export type UpdateTasksByProjectIdMutationFn = Apollo.MutationFunction<UpdateTasksByProjectIdMutation, UpdateTasksByProjectIdMutationVariables>;

/**
 * __useUpdateTasksByProjectIdMutation__
 *
 * To run a mutation, you first call `useUpdateTasksByProjectIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTasksByProjectIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTasksByProjectIdMutation, { data, loading, error }] = useUpdateTasksByProjectIdMutation({
 *   variables: {
 *      toStatus: // value for 'toStatus'
 *      fromStatus: // value for 'fromStatus'
 *      toHelperId: // value for 'toHelperId'
 *      fromHelperId: // value for 'fromHelperId'
 *      toAuditorId: // value for 'toAuditorId'
 *      fromAuditorId: // value for 'fromAuditorId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateTasksByProjectIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTasksByProjectIdMutation, UpdateTasksByProjectIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTasksByProjectIdMutation, UpdateTasksByProjectIdMutationVariables>(UpdateTasksByProjectIdDocument, options);
      }
export type UpdateTasksByProjectIdMutationHookResult = ReturnType<typeof useUpdateTasksByProjectIdMutation>;
export type UpdateTasksByProjectIdMutationResult = Apollo.MutationResult<UpdateTasksByProjectIdMutation>;
export type UpdateTasksByProjectIdMutationOptions = Apollo.BaseMutationOptions<UpdateTasksByProjectIdMutation, UpdateTasksByProjectIdMutationVariables>;
export const StartTaskingDocument = gql`
    mutation StartTasking($projectId: Int!) {
  startTasking(projectId: $projectId) {
    ...TaskFields
  }
}
    ${TaskFieldsFragmentDoc}`;
export type StartTaskingMutationFn = Apollo.MutationFunction<StartTaskingMutation, StartTaskingMutationVariables>;

/**
 * __useStartTaskingMutation__
 *
 * To run a mutation, you first call `useStartTaskingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTaskingMutation, { data, loading, error }] = useStartTaskingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useStartTaskingMutation(baseOptions?: Apollo.MutationHookOptions<StartTaskingMutation, StartTaskingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTaskingMutation, StartTaskingMutationVariables>(StartTaskingDocument, options);
      }
export type StartTaskingMutationHookResult = ReturnType<typeof useStartTaskingMutation>;
export type StartTaskingMutationResult = Apollo.MutationResult<StartTaskingMutation>;
export type StartTaskingMutationOptions = Apollo.BaseMutationOptions<StartTaskingMutation, StartTaskingMutationVariables>;
export const StartAuditingDocument = gql`
    mutation StartAuditing($projectId: Int!) {
  startAuditing(projectId: $projectId) {
    ...TaskFields
  }
}
    ${TaskFieldsFragmentDoc}`;
export type StartAuditingMutationFn = Apollo.MutationFunction<StartAuditingMutation, StartAuditingMutationVariables>;

/**
 * __useStartAuditingMutation__
 *
 * To run a mutation, you first call `useStartAuditingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAuditingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAuditingMutation, { data, loading, error }] = useStartAuditingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useStartAuditingMutation(baseOptions?: Apollo.MutationHookOptions<StartAuditingMutation, StartAuditingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAuditingMutation, StartAuditingMutationVariables>(StartAuditingDocument, options);
      }
export type StartAuditingMutationHookResult = ReturnType<typeof useStartAuditingMutation>;
export type StartAuditingMutationResult = Apollo.MutationResult<StartAuditingMutation>;
export type StartAuditingMutationOptions = Apollo.BaseMutationOptions<StartAuditingMutation, StartAuditingMutationVariables>;
export const SubmitTaskDocument = gql`
    mutation SubmitTask($action: TaskAction!, $taskId: Int!, $result: JSONObject, $comment: String) {
  submitTask(action: $action, taskId: $taskId, result: $result, comment: $comment) {
    newTask {
      ...TaskFields
    }
    processedTask {
      ...TaskFields
    }
  }
}
    ${TaskFieldsFragmentDoc}`;
export type SubmitTaskMutationFn = Apollo.MutationFunction<SubmitTaskMutation, SubmitTaskMutationVariables>;

/**
 * __useSubmitTaskMutation__
 *
 * To run a mutation, you first call `useSubmitTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTaskMutation, { data, loading, error }] = useSubmitTaskMutation({
 *   variables: {
 *      action: // value for 'action'
 *      taskId: // value for 'taskId'
 *      result: // value for 'result'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSubmitTaskMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTaskMutation, SubmitTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTaskMutation, SubmitTaskMutationVariables>(SubmitTaskDocument, options);
      }
export type SubmitTaskMutationHookResult = ReturnType<typeof useSubmitTaskMutation>;
export type SubmitTaskMutationResult = Apollo.MutationResult<SubmitTaskMutation>;
export type SubmitTaskMutationOptions = Apollo.BaseMutationOptions<SubmitTaskMutation, SubmitTaskMutationVariables>;
export const AutosaveTaskDocument = gql`
    mutation AutosaveTask($result: JSONObject, $taskId: Int!) {
  autosaveTask(result: $result, taskId: $taskId) {
    id
  }
}
    `;
export type AutosaveTaskMutationFn = Apollo.MutationFunction<AutosaveTaskMutation, AutosaveTaskMutationVariables>;

/**
 * __useAutosaveTaskMutation__
 *
 * To run a mutation, you first call `useAutosaveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutosaveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autosaveTaskMutation, { data, loading, error }] = useAutosaveTaskMutation({
 *   variables: {
 *      result: // value for 'result'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAutosaveTaskMutation(baseOptions?: Apollo.MutationHookOptions<AutosaveTaskMutation, AutosaveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutosaveTaskMutation, AutosaveTaskMutationVariables>(AutosaveTaskDocument, options);
      }
export type AutosaveTaskMutationHookResult = ReturnType<typeof useAutosaveTaskMutation>;
export type AutosaveTaskMutationResult = Apollo.MutationResult<AutosaveTaskMutation>;
export type AutosaveTaskMutationOptions = Apollo.BaseMutationOptions<AutosaveTaskMutation, AutosaveTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($fromAuditorId: Int, $fromHelperId: Int, $fromStatus: TaskStatus, $taskId: Int!, $toAuditorId: Int, $toHelperId: Int, $toStatus: TaskStatus) {
  updateTask(
    fromAuditorId: $fromAuditorId
    fromHelperId: $fromHelperId
    fromStatus: $fromStatus
    taskId: $taskId
    toAuditorId: $toAuditorId
    toHelperId: $toAuditorId
    toStatus: $toStatus
  ) {
    id
    auditorId
    helperId
    projectId
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      fromAuditorId: // value for 'fromAuditorId'
 *      fromHelperId: // value for 'fromHelperId'
 *      fromStatus: // value for 'fromStatus'
 *      taskId: // value for 'taskId'
 *      toAuditorId: // value for 'toAuditorId'
 *      toHelperId: // value for 'toHelperId'
 *      toStatus: // value for 'toStatus'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const SelectTaskDocument = gql`
    mutation SelectTask($taskId: Int!) {
  selectTask(taskId: $taskId) {
    ...TaskFields
  }
}
    ${TaskFieldsFragmentDoc}`;
export type SelectTaskMutationFn = Apollo.MutationFunction<SelectTaskMutation, SelectTaskMutationVariables>;

/**
 * __useSelectTaskMutation__
 *
 * To run a mutation, you first call `useSelectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectTaskMutation, { data, loading, error }] = useSelectTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useSelectTaskMutation(baseOptions?: Apollo.MutationHookOptions<SelectTaskMutation, SelectTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectTaskMutation, SelectTaskMutationVariables>(SelectTaskDocument, options);
      }
export type SelectTaskMutationHookResult = ReturnType<typeof useSelectTaskMutation>;
export type SelectTaskMutationResult = Apollo.MutationResult<SelectTaskMutation>;
export type SelectTaskMutationOptions = Apollo.BaseMutationOptions<SelectTaskMutation, SelectTaskMutationVariables>;
export const ListClientsDocument = gql`
    query ListClients($helperId: Int, $page: Int, $returnAllData: Boolean) {
  listClients(helperId: $helperId, page: $page, returnAllData: $returnAllData) {
    pagesCount
    clients {
      ...ClientDetailsFields
    }
  }
}
    ${ClientDetailsFieldsFragmentDoc}`;

/**
 * __useListClientsQuery__
 *
 * To run a query within a React component, call `useListClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientsQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *      page: // value for 'page'
 *      returnAllData: // value for 'returnAllData'
 *   },
 * });
 */
export function useListClientsQuery(baseOptions?: Apollo.QueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, options);
      }
export function useListClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClientsQuery, ListClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClientsQuery, ListClientsQueryVariables>(ListClientsDocument, options);
        }
export type ListClientsQueryHookResult = ReturnType<typeof useListClientsQuery>;
export type ListClientsLazyQueryHookResult = ReturnType<typeof useListClientsLazyQuery>;
export type ListClientsQueryResult = Apollo.QueryResult<ListClientsQuery, ListClientsQueryVariables>;
export const ClientCurrentTasksStateReportDocument = gql`
    query ClientCurrentTasksStateReport($clientId: Int!, $dateFrom: DateTime!, $dateTo: DateTime!, $projectId: Int) {
  clientProjectsReport(
    responseFormat: JSON
    projectId: $projectId
    dateFrom: $dateFrom
    clientId: $clientId
    dateTo: $dateTo
  ) {
    JSON {
      helperRate
      client {
        companyName
      }
      id
      labels
      newTasksCount
      startedTasksCount
      inAuditTasksCount
      rejectedTasksCount
      completedTasksCount
      totalTasksCount
      title
      type
      auditorRate
      auditorsCount
      workPoints
      updatedAt
      createdAt
    }
  }
}
    `;

/**
 * __useClientCurrentTasksStateReportQuery__
 *
 * To run a query within a React component, call `useClientCurrentTasksStateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCurrentTasksStateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCurrentTasksStateReportQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useClientCurrentTasksStateReportQuery(baseOptions: Apollo.QueryHookOptions<ClientCurrentTasksStateReportQuery, ClientCurrentTasksStateReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCurrentTasksStateReportQuery, ClientCurrentTasksStateReportQueryVariables>(ClientCurrentTasksStateReportDocument, options);
      }
export function useClientCurrentTasksStateReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCurrentTasksStateReportQuery, ClientCurrentTasksStateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCurrentTasksStateReportQuery, ClientCurrentTasksStateReportQueryVariables>(ClientCurrentTasksStateReportDocument, options);
        }
export type ClientCurrentTasksStateReportQueryHookResult = ReturnType<typeof useClientCurrentTasksStateReportQuery>;
export type ClientCurrentTasksStateReportLazyQueryHookResult = ReturnType<typeof useClientCurrentTasksStateReportLazyQuery>;
export type ClientCurrentTasksStateReportQueryResult = Apollo.QueryResult<ClientCurrentTasksStateReportQuery, ClientCurrentTasksStateReportQueryVariables>;
export const ClientCurrentTasksStateReportCsvDocument = gql`
    query ClientCurrentTasksStateReportCsv($clientId: Int!, $dateFrom: DateTime!, $dateTo: DateTime!, $projectId: Int) {
  clientProjectsReport(
    responseFormat: CSV
    projectId: $projectId
    dateFrom: $dateFrom
    clientId: $clientId
    dateTo: $dateTo
  ) {
    CSV
  }
}
    `;

/**
 * __useClientCurrentTasksStateReportCsvQuery__
 *
 * To run a query within a React component, call `useClientCurrentTasksStateReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCurrentTasksStateReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCurrentTasksStateReportCsvQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useClientCurrentTasksStateReportCsvQuery(baseOptions: Apollo.QueryHookOptions<ClientCurrentTasksStateReportCsvQuery, ClientCurrentTasksStateReportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCurrentTasksStateReportCsvQuery, ClientCurrentTasksStateReportCsvQueryVariables>(ClientCurrentTasksStateReportCsvDocument, options);
      }
export function useClientCurrentTasksStateReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCurrentTasksStateReportCsvQuery, ClientCurrentTasksStateReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCurrentTasksStateReportCsvQuery, ClientCurrentTasksStateReportCsvQueryVariables>(ClientCurrentTasksStateReportCsvDocument, options);
        }
export type ClientCurrentTasksStateReportCsvQueryHookResult = ReturnType<typeof useClientCurrentTasksStateReportCsvQuery>;
export type ClientCurrentTasksStateReportCsvLazyQueryHookResult = ReturnType<typeof useClientCurrentTasksStateReportCsvLazyQuery>;
export type ClientCurrentTasksStateReportCsvQueryResult = Apollo.QueryResult<ClientCurrentTasksStateReportCsvQuery, ClientCurrentTasksStateReportCsvQueryVariables>;
export const HelpersDocument = gql`
    query Helpers($page: Int, $returnAllData: Boolean) {
  helpers(returnAllData: $returnAllData, page: $page) {
    pagesCount
    helpers {
      activated
      email
      firstName
      id
      isDeleted
      lastName
      enabled
      assignedToProjectAsAuditor
      assignedToProjectAsHelper
    }
  }
}
    `;

/**
 * __useHelpersQuery__
 *
 * To run a query within a React component, call `useHelpersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      returnAllData: // value for 'returnAllData'
 *   },
 * });
 */
export function useHelpersQuery(baseOptions?: Apollo.QueryHookOptions<HelpersQuery, HelpersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelpersQuery, HelpersQueryVariables>(HelpersDocument, options);
      }
export function useHelpersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelpersQuery, HelpersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelpersQuery, HelpersQueryVariables>(HelpersDocument, options);
        }
export type HelpersQueryHookResult = ReturnType<typeof useHelpersQuery>;
export type HelpersLazyQueryHookResult = ReturnType<typeof useHelpersLazyQuery>;
export type HelpersQueryResult = Apollo.QueryResult<HelpersQuery, HelpersQueryVariables>;
export const GetHelperByIdDocument = gql`
    query GetHelperById($helperId: Int!) {
  helper(helperId: $helperId) {
    assignedToProjectAsAuditor
    assignedToProjectAsHelper
    activated
    email
    enabled
    firstName
    id
    isDeleted
    lastName
  }
}
    `;

/**
 * __useGetHelperByIdQuery__
 *
 * To run a query within a React component, call `useGetHelperByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelperByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelperByIdQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useGetHelperByIdQuery(baseOptions: Apollo.QueryHookOptions<GetHelperByIdQuery, GetHelperByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelperByIdQuery, GetHelperByIdQueryVariables>(GetHelperByIdDocument, options);
      }
export function useGetHelperByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelperByIdQuery, GetHelperByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelperByIdQuery, GetHelperByIdQueryVariables>(GetHelperByIdDocument, options);
        }
export type GetHelperByIdQueryHookResult = ReturnType<typeof useGetHelperByIdQuery>;
export type GetHelperByIdLazyQueryHookResult = ReturnType<typeof useGetHelperByIdLazyQuery>;
export type GetHelperByIdQueryResult = Apollo.QueryResult<GetHelperByIdQuery, GetHelperByIdQueryVariables>;
export const GetAssignedHelpersListDocument = gql`
    query GetAssignedHelpersList($projectId: Int) {
  helpers(active: true, projectId: $projectId, returnAllData: true) {
    pagesCount
    helpers {
      activated
      email
      firstName
      id
      isDeleted
      lastName
      enabled
      assignedToProjectAsAuditor
      assignedToProjectAsHelper
    }
  }
}
    `;

/**
 * __useGetAssignedHelpersListQuery__
 *
 * To run a query within a React component, call `useGetAssignedHelpersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedHelpersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedHelpersListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAssignedHelpersListQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignedHelpersListQuery, GetAssignedHelpersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedHelpersListQuery, GetAssignedHelpersListQueryVariables>(GetAssignedHelpersListDocument, options);
      }
export function useGetAssignedHelpersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedHelpersListQuery, GetAssignedHelpersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedHelpersListQuery, GetAssignedHelpersListQueryVariables>(GetAssignedHelpersListDocument, options);
        }
export type GetAssignedHelpersListQueryHookResult = ReturnType<typeof useGetAssignedHelpersListQuery>;
export type GetAssignedHelpersListLazyQueryHookResult = ReturnType<typeof useGetAssignedHelpersListLazyQuery>;
export type GetAssignedHelpersListQueryResult = Apollo.QueryResult<GetAssignedHelpersListQuery, GetAssignedHelpersListQueryVariables>;
export const ReportsGetHelpersStatsByPrjIdDocument = gql`
    query ReportsGetHelpersStatsByPrjId($projectId: Int!) {
  helpersStatsByProject(projectId: $projectId, responseFormat: JSON) {
    JSON {
      firstName
      helperPoints
      helperRate
      auditorPoints
      id
      auditorPoints
      auditorRate
      lastName
      penalties
      auditorTasksCount
    }
    CSV
  }
}
    `;

/**
 * __useReportsGetHelpersStatsByPrjIdQuery__
 *
 * To run a query within a React component, call `useReportsGetHelpersStatsByPrjIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsGetHelpersStatsByPrjIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsGetHelpersStatsByPrjIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useReportsGetHelpersStatsByPrjIdQuery(baseOptions: Apollo.QueryHookOptions<ReportsGetHelpersStatsByPrjIdQuery, ReportsGetHelpersStatsByPrjIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsGetHelpersStatsByPrjIdQuery, ReportsGetHelpersStatsByPrjIdQueryVariables>(ReportsGetHelpersStatsByPrjIdDocument, options);
      }
export function useReportsGetHelpersStatsByPrjIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsGetHelpersStatsByPrjIdQuery, ReportsGetHelpersStatsByPrjIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsGetHelpersStatsByPrjIdQuery, ReportsGetHelpersStatsByPrjIdQueryVariables>(ReportsGetHelpersStatsByPrjIdDocument, options);
        }
export type ReportsGetHelpersStatsByPrjIdQueryHookResult = ReturnType<typeof useReportsGetHelpersStatsByPrjIdQuery>;
export type ReportsGetHelpersStatsByPrjIdLazyQueryHookResult = ReturnType<typeof useReportsGetHelpersStatsByPrjIdLazyQuery>;
export type ReportsGetHelpersStatsByPrjIdQueryResult = Apollo.QueryResult<ReportsGetHelpersStatsByPrjIdQuery, ReportsGetHelpersStatsByPrjIdQueryVariables>;
export const ReportsGetHelpersStatsByPrjIdCsvDocument = gql`
    query ReportsGetHelpersStatsByPrjIdCsv($projectId: Int!) {
  helpersStatsByProject(projectId: $projectId, responseFormat: CSV) {
    CSV
  }
}
    `;

/**
 * __useReportsGetHelpersStatsByPrjIdCsvQuery__
 *
 * To run a query within a React component, call `useReportsGetHelpersStatsByPrjIdCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsGetHelpersStatsByPrjIdCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsGetHelpersStatsByPrjIdCsvQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useReportsGetHelpersStatsByPrjIdCsvQuery(baseOptions: Apollo.QueryHookOptions<ReportsGetHelpersStatsByPrjIdCsvQuery, ReportsGetHelpersStatsByPrjIdCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsGetHelpersStatsByPrjIdCsvQuery, ReportsGetHelpersStatsByPrjIdCsvQueryVariables>(ReportsGetHelpersStatsByPrjIdCsvDocument, options);
      }
export function useReportsGetHelpersStatsByPrjIdCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsGetHelpersStatsByPrjIdCsvQuery, ReportsGetHelpersStatsByPrjIdCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsGetHelpersStatsByPrjIdCsvQuery, ReportsGetHelpersStatsByPrjIdCsvQueryVariables>(ReportsGetHelpersStatsByPrjIdCsvDocument, options);
        }
export type ReportsGetHelpersStatsByPrjIdCsvQueryHookResult = ReturnType<typeof useReportsGetHelpersStatsByPrjIdCsvQuery>;
export type ReportsGetHelpersStatsByPrjIdCsvLazyQueryHookResult = ReturnType<typeof useReportsGetHelpersStatsByPrjIdCsvLazyQuery>;
export type ReportsGetHelpersStatsByPrjIdCsvQueryResult = Apollo.QueryResult<ReportsGetHelpersStatsByPrjIdCsvQuery, ReportsGetHelpersStatsByPrjIdCsvQueryVariables>;
export const GetListOfHelpersDocument = gql`
    query GetListOfHelpers($projectId: Int) {
  getListOfHelpers(projectId: $projectId) {
    invited {
      lastName
      firstName
      email
    }
    requested {
      lastName
      firstName
      email
    }
    pending {
      lastName
      firstName
      email
    }
  }
}
    `;

/**
 * __useGetListOfHelpersQuery__
 *
 * To run a query within a React component, call `useGetListOfHelpersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfHelpersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOfHelpersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetListOfHelpersQuery(baseOptions?: Apollo.QueryHookOptions<GetListOfHelpersQuery, GetListOfHelpersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListOfHelpersQuery, GetListOfHelpersQueryVariables>(GetListOfHelpersDocument, options);
      }
export function useGetListOfHelpersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListOfHelpersQuery, GetListOfHelpersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListOfHelpersQuery, GetListOfHelpersQueryVariables>(GetListOfHelpersDocument, options);
        }
export type GetListOfHelpersQueryHookResult = ReturnType<typeof useGetListOfHelpersQuery>;
export type GetListOfHelpersLazyQueryHookResult = ReturnType<typeof useGetListOfHelpersLazyQuery>;
export type GetListOfHelpersQueryResult = Apollo.QueryResult<GetListOfHelpersQuery, GetListOfHelpersQueryVariables>;
export const GetLearningProgressDocument = gql`
    query GetLearningProgress {
  getLearningProgress {
    id
    lessons {
      id
    }
  }
}
    `;

/**
 * __useGetLearningProgressQuery__
 *
 * To run a query within a React component, call `useGetLearningProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetLearningProgressQuery, GetLearningProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningProgressQuery, GetLearningProgressQueryVariables>(GetLearningProgressDocument, options);
      }
export function useGetLearningProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningProgressQuery, GetLearningProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningProgressQuery, GetLearningProgressQueryVariables>(GetLearningProgressDocument, options);
        }
export type GetLearningProgressQueryHookResult = ReturnType<typeof useGetLearningProgressQuery>;
export type GetLearningProgressLazyQueryHookResult = ReturnType<typeof useGetLearningProgressLazyQuery>;
export type GetLearningProgressQueryResult = Apollo.QueryResult<GetLearningProgressQuery, GetLearningProgressQueryVariables>;
export const GetAllTimeStatsDocument = gql`
    query GetAllTimeStats {
  getHelperStatistic {
    dailyStat {
      projectDone
      taskCompleted
      taskReturned
      totalEarned
    }
    projectDone
    taskCompleted
    taskReturned
    totalEarned
  }
}
    `;

/**
 * __useGetAllTimeStatsQuery__
 *
 * To run a query within a React component, call `useGetAllTimeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTimeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTimeStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTimeStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTimeStatsQuery, GetAllTimeStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTimeStatsQuery, GetAllTimeStatsQueryVariables>(GetAllTimeStatsDocument, options);
      }
export function useGetAllTimeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTimeStatsQuery, GetAllTimeStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTimeStatsQuery, GetAllTimeStatsQueryVariables>(GetAllTimeStatsDocument, options);
        }
export type GetAllTimeStatsQueryHookResult = ReturnType<typeof useGetAllTimeStatsQuery>;
export type GetAllTimeStatsLazyQueryHookResult = ReturnType<typeof useGetAllTimeStatsLazyQuery>;
export type GetAllTimeStatsQueryResult = Apollo.QueryResult<GetAllTimeStatsQuery, GetAllTimeStatsQueryVariables>;
export const GetLearningMaterialsStructureDocument = gql`
    query GetLearningMaterialsStructure {
  getLearningMaterialsStructure {
    topics {
      id
      title
      lessons {
        id
        title
        isDone
      }
    }
  }
}
    `;

/**
 * __useGetLearningMaterialsStructureQuery__
 *
 * To run a query within a React component, call `useGetLearningMaterialsStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningMaterialsStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningMaterialsStructureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningMaterialsStructureQuery(baseOptions?: Apollo.QueryHookOptions<GetLearningMaterialsStructureQuery, GetLearningMaterialsStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningMaterialsStructureQuery, GetLearningMaterialsStructureQueryVariables>(GetLearningMaterialsStructureDocument, options);
      }
export function useGetLearningMaterialsStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningMaterialsStructureQuery, GetLearningMaterialsStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningMaterialsStructureQuery, GetLearningMaterialsStructureQueryVariables>(GetLearningMaterialsStructureDocument, options);
        }
export type GetLearningMaterialsStructureQueryHookResult = ReturnType<typeof useGetLearningMaterialsStructureQuery>;
export type GetLearningMaterialsStructureLazyQueryHookResult = ReturnType<typeof useGetLearningMaterialsStructureLazyQuery>;
export type GetLearningMaterialsStructureQueryResult = Apollo.QueryResult<GetLearningMaterialsStructureQuery, GetLearningMaterialsStructureQueryVariables>;
export const GetLessonLearningMaterialDocument = gql`
    query GetLessonLearningMaterial($helperId: Int!, $lessonId: Int!, $topicId: Int!) {
  getLessonLearningMaterial(
    helperId: $helperId
    lessonId: $lessonId
    topicId: $topicId
  ) {
    description
    images
    practice {
      id
      title
      avgResult
    }
  }
}
    `;

/**
 * __useGetLessonLearningMaterialQuery__
 *
 * To run a query within a React component, call `useGetLessonLearningMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonLearningMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonLearningMaterialQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *      lessonId: // value for 'lessonId'
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useGetLessonLearningMaterialQuery(baseOptions: Apollo.QueryHookOptions<GetLessonLearningMaterialQuery, GetLessonLearningMaterialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonLearningMaterialQuery, GetLessonLearningMaterialQueryVariables>(GetLessonLearningMaterialDocument, options);
      }
export function useGetLessonLearningMaterialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonLearningMaterialQuery, GetLessonLearningMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonLearningMaterialQuery, GetLessonLearningMaterialQueryVariables>(GetLessonLearningMaterialDocument, options);
        }
export type GetLessonLearningMaterialQueryHookResult = ReturnType<typeof useGetLessonLearningMaterialQuery>;
export type GetLessonLearningMaterialLazyQueryHookResult = ReturnType<typeof useGetLessonLearningMaterialLazyQuery>;
export type GetLessonLearningMaterialQueryResult = Apollo.QueryResult<GetLessonLearningMaterialQuery, GetLessonLearningMaterialQueryVariables>;
export const StartPracticeSessionDocument = gql`
    query StartPracticeSession($lessonId: Int!, $practiceId: Int!, $topicId: Int!) {
  startPracticSession(
    lessonId: $lessonId
    practiceId: $practiceId
    topicId: $topicId
  ) {
    task {
      type
      mediaFileName
      mediaUrl
      settings {
        chunkLength
        subType
        annotationType
      }
      labels
      videoStart
      videoEnd
      videoFPS
      videoFrameCount
      videoChunkLength
    }
    sessionEndDate
    totalSessionSize
  }
}
    `;

/**
 * __useStartPracticeSessionQuery__
 *
 * To run a query within a React component, call `useStartPracticeSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartPracticeSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartPracticeSessionQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      practiceId: // value for 'practiceId'
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useStartPracticeSessionQuery(baseOptions: Apollo.QueryHookOptions<StartPracticeSessionQuery, StartPracticeSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartPracticeSessionQuery, StartPracticeSessionQueryVariables>(StartPracticeSessionDocument, options);
      }
export function useStartPracticeSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartPracticeSessionQuery, StartPracticeSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartPracticeSessionQuery, StartPracticeSessionQueryVariables>(StartPracticeSessionDocument, options);
        }
export type StartPracticeSessionQueryHookResult = ReturnType<typeof useStartPracticeSessionQuery>;
export type StartPracticeSessionLazyQueryHookResult = ReturnType<typeof useStartPracticeSessionLazyQuery>;
export type StartPracticeSessionQueryResult = Apollo.QueryResult<StartPracticeSessionQuery, StartPracticeSessionQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($projectId: Int!) {
  project(projectId: $projectId) {
    ...ProjectDetailFields
  }
}
    ${ProjectDetailFieldsFragmentDoc}`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const ProjectResultsDocument = gql`
    query ProjectResults($uploadToGDrive: Boolean, $projectId: Int!) {
  projectResults(projectId: $projectId, uploadToGDrive: $uploadToGDrive) {
    id
    results
  }
}
    `;

/**
 * __useProjectResultsQuery__
 *
 * To run a query within a React component, call `useProjectResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectResultsQuery({
 *   variables: {
 *      uploadToGDrive: // value for 'uploadToGDrive'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectResultsQuery(baseOptions: Apollo.QueryHookOptions<ProjectResultsQuery, ProjectResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectResultsQuery, ProjectResultsQueryVariables>(ProjectResultsDocument, options);
      }
export function useProjectResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectResultsQuery, ProjectResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectResultsQuery, ProjectResultsQueryVariables>(ProjectResultsDocument, options);
        }
export type ProjectResultsQueryHookResult = ReturnType<typeof useProjectResultsQuery>;
export type ProjectResultsLazyQueryHookResult = ReturnType<typeof useProjectResultsLazyQuery>;
export type ProjectResultsQueryResult = Apollo.QueryResult<ProjectResultsQuery, ProjectResultsQueryVariables>;
export const ListProjectsDocument = gql`
    query ListProjects($clientId: Int, $sortByDateOrder: SortByDateOrder, $page: Int, $returnAllData: Boolean, $isReadyForReport: Boolean) {
  listProjects(
    clientId: $clientId
    sortByDateOrder: $sortByDateOrder
    page: $page
    returnAllData: $returnAllData
    isReadyForReport: $isReadyForReport
  ) {
    pagesCount
    projects {
      ...ProjectDetailFields
    }
  }
}
    ${ProjectDetailFieldsFragmentDoc}`;

/**
 * __useListProjectsQuery__
 *
 * To run a query within a React component, call `useListProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      sortByDateOrder: // value for 'sortByDateOrder'
 *      page: // value for 'page'
 *      returnAllData: // value for 'returnAllData'
 *      isReadyForReport: // value for 'isReadyForReport'
 *   },
 * });
 */
export function useListProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
      }
export function useListProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
        }
export type ListProjectsQueryHookResult = ReturnType<typeof useListProjectsQuery>;
export type ListProjectsLazyQueryHookResult = ReturnType<typeof useListProjectsLazyQuery>;
export type ListProjectsQueryResult = Apollo.QueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export const ListUnreviewdProjectsDocument = gql`
    query ListUnreviewdProjects($sortByDateOrder: SortByDateOrder, $page: Int) {
  listUnreviewedProjects(sortByDateOrder: $sortByDateOrder, page: $page) {
    pagesCount
    projects {
      ...ProjectDetailFields
    }
  }
}
    ${ProjectDetailFieldsFragmentDoc}`;

/**
 * __useListUnreviewdProjectsQuery__
 *
 * To run a query within a React component, call `useListUnreviewdProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUnreviewdProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUnreviewdProjectsQuery({
 *   variables: {
 *      sortByDateOrder: // value for 'sortByDateOrder'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useListUnreviewdProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ListUnreviewdProjectsQuery, ListUnreviewdProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUnreviewdProjectsQuery, ListUnreviewdProjectsQueryVariables>(ListUnreviewdProjectsDocument, options);
      }
export function useListUnreviewdProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUnreviewdProjectsQuery, ListUnreviewdProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUnreviewdProjectsQuery, ListUnreviewdProjectsQueryVariables>(ListUnreviewdProjectsDocument, options);
        }
export type ListUnreviewdProjectsQueryHookResult = ReturnType<typeof useListUnreviewdProjectsQuery>;
export type ListUnreviewdProjectsLazyQueryHookResult = ReturnType<typeof useListUnreviewdProjectsLazyQuery>;
export type ListUnreviewdProjectsQueryResult = Apollo.QueryResult<ListUnreviewdProjectsQuery, ListUnreviewdProjectsQueryVariables>;
export const GetProjectByIdDocument = gql`
    query GetProjectById($projectId: Int!) {
  project(projectId: $projectId) {
    ...ProjectDetailFields
  }
}
    ${ProjectDetailFieldsFragmentDoc}`;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
      }
export function useGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
        }
export type GetProjectByIdQueryHookResult = ReturnType<typeof useGetProjectByIdQuery>;
export type GetProjectByIdLazyQueryHookResult = ReturnType<typeof useGetProjectByIdLazyQuery>;
export type GetProjectByIdQueryResult = Apollo.QueryResult<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const AssignedProjectTitlesToHelperDocument = gql`
    query AssignedProjectTitlesToHelper($helperId: Int!) {
  assignedProjectTitlesToHelper(helperId: $helperId)
}
    `;

/**
 * __useAssignedProjectTitlesToHelperQuery__
 *
 * To run a query within a React component, call `useAssignedProjectTitlesToHelperQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedProjectTitlesToHelperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedProjectTitlesToHelperQuery({
 *   variables: {
 *      helperId: // value for 'helperId'
 *   },
 * });
 */
export function useAssignedProjectTitlesToHelperQuery(baseOptions: Apollo.QueryHookOptions<AssignedProjectTitlesToHelperQuery, AssignedProjectTitlesToHelperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedProjectTitlesToHelperQuery, AssignedProjectTitlesToHelperQueryVariables>(AssignedProjectTitlesToHelperDocument, options);
      }
export function useAssignedProjectTitlesToHelperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedProjectTitlesToHelperQuery, AssignedProjectTitlesToHelperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedProjectTitlesToHelperQuery, AssignedProjectTitlesToHelperQueryVariables>(AssignedProjectTitlesToHelperDocument, options);
        }
export type AssignedProjectTitlesToHelperQueryHookResult = ReturnType<typeof useAssignedProjectTitlesToHelperQuery>;
export type AssignedProjectTitlesToHelperLazyQueryHookResult = ReturnType<typeof useAssignedProjectTitlesToHelperLazyQuery>;
export type AssignedProjectTitlesToHelperQueryResult = Apollo.QueryResult<AssignedProjectTitlesToHelperQuery, AssignedProjectTitlesToHelperQueryVariables>;
export const ProjectTitleUniqDocument = gql`
    query ProjectTitleUniq($clientId: Int!, $title: String!) {
  projectTitleIsUnique(clientId: $clientId, title: $title)
}
    `;

/**
 * __useProjectTitleUniqQuery__
 *
 * To run a query within a React component, call `useProjectTitleUniqQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTitleUniqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTitleUniqQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useProjectTitleUniqQuery(baseOptions: Apollo.QueryHookOptions<ProjectTitleUniqQuery, ProjectTitleUniqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTitleUniqQuery, ProjectTitleUniqQueryVariables>(ProjectTitleUniqDocument, options);
      }
export function useProjectTitleUniqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTitleUniqQuery, ProjectTitleUniqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTitleUniqQuery, ProjectTitleUniqQueryVariables>(ProjectTitleUniqDocument, options);
        }
export type ProjectTitleUniqQueryHookResult = ReturnType<typeof useProjectTitleUniqQuery>;
export type ProjectTitleUniqLazyQueryHookResult = ReturnType<typeof useProjectTitleUniqLazyQuery>;
export type ProjectTitleUniqQueryResult = Apollo.QueryResult<ProjectTitleUniqQuery, ProjectTitleUniqQueryVariables>;
export const ProjectGenerateCocoReportDocument = gql`
    query ProjectGenerateCocoReport($clientId: Int!, $projectId: Int!) {
  generateCoCoReport(clientId: $clientId, projectId: $projectId)
}
    `;

/**
 * __useProjectGenerateCocoReportQuery__
 *
 * To run a query within a React component, call `useProjectGenerateCocoReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGenerateCocoReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGenerateCocoReportQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectGenerateCocoReportQuery(baseOptions: Apollo.QueryHookOptions<ProjectGenerateCocoReportQuery, ProjectGenerateCocoReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectGenerateCocoReportQuery, ProjectGenerateCocoReportQueryVariables>(ProjectGenerateCocoReportDocument, options);
      }
export function useProjectGenerateCocoReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectGenerateCocoReportQuery, ProjectGenerateCocoReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectGenerateCocoReportQuery, ProjectGenerateCocoReportQueryVariables>(ProjectGenerateCocoReportDocument, options);
        }
export type ProjectGenerateCocoReportQueryHookResult = ReturnType<typeof useProjectGenerateCocoReportQuery>;
export type ProjectGenerateCocoReportLazyQueryHookResult = ReturnType<typeof useProjectGenerateCocoReportLazyQuery>;
export type ProjectGenerateCocoReportQueryResult = Apollo.QueryResult<ProjectGenerateCocoReportQuery, ProjectGenerateCocoReportQueryVariables>;
export const ProjectGenerateYoloReportDocument = gql`
    query ProjectGenerateYoloReport($clientId: Int!, $projectId: Int!) {
  generateYoloReport(clientId: $clientId, projectId: $projectId)
}
    `;

/**
 * __useProjectGenerateYoloReportQuery__
 *
 * To run a query within a React component, call `useProjectGenerateYoloReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGenerateYoloReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGenerateYoloReportQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectGenerateYoloReportQuery(baseOptions: Apollo.QueryHookOptions<ProjectGenerateYoloReportQuery, ProjectGenerateYoloReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectGenerateYoloReportQuery, ProjectGenerateYoloReportQueryVariables>(ProjectGenerateYoloReportDocument, options);
      }
export function useProjectGenerateYoloReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectGenerateYoloReportQuery, ProjectGenerateYoloReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectGenerateYoloReportQuery, ProjectGenerateYoloReportQueryVariables>(ProjectGenerateYoloReportDocument, options);
        }
export type ProjectGenerateYoloReportQueryHookResult = ReturnType<typeof useProjectGenerateYoloReportQuery>;
export type ProjectGenerateYoloReportLazyQueryHookResult = ReturnType<typeof useProjectGenerateYoloReportLazyQuery>;
export type ProjectGenerateYoloReportQueryResult = Apollo.QueryResult<ProjectGenerateYoloReportQuery, ProjectGenerateYoloReportQueryVariables>;
export const GetTaskByIdDocument = gql`
    query GetTaskById($taskId: Int!) {
  task(taskId: $taskId) {
    ...TaskFields
  }
}
    ${TaskFieldsFragmentDoc}`;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByIdQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
      }
export function useGetTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
        }
export type GetTaskByIdQueryHookResult = ReturnType<typeof useGetTaskByIdQuery>;
export type GetTaskByIdLazyQueryHookResult = ReturnType<typeof useGetTaskByIdLazyQuery>;
export type GetTaskByIdQueryResult = Apollo.QueryResult<GetTaskByIdQuery, GetTaskByIdQueryVariables>;
export const GetTaskListDocument = gql`
    query GetTaskList($projectId: Int!) {
  taskList(projectId: $projectId) {
    ...TaskFragmentFields
  }
}
    ${TaskFragmentFieldsFragmentDoc}`;

/**
 * __useGetTaskListQuery__
 *
 * To run a query within a React component, call `useGetTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetTaskListQuery(baseOptions: Apollo.QueryHookOptions<GetTaskListQuery, GetTaskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskListQuery, GetTaskListQueryVariables>(GetTaskListDocument, options);
      }
export function useGetTaskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskListQuery, GetTaskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskListQuery, GetTaskListQueryVariables>(GetTaskListDocument, options);
        }
export type GetTaskListQueryHookResult = ReturnType<typeof useGetTaskListQuery>;
export type GetTaskListLazyQueryHookResult = ReturnType<typeof useGetTaskListLazyQuery>;
export type GetTaskListQueryResult = Apollo.QueryResult<GetTaskListQuery, GetTaskListQueryVariables>;